export default {
  message: {
    details: 'Details',
    back: 'Zurück',
    exportDataTitle: 'Laden Sie Listen als Excel-Datei herunter',
    mobile_phone: '(Mobiel) Telefoonnummer',
    sales_representative: 'Vertriebsmitarbeiter',
    commitment_letter_accept: 'Commitment letter accept',
    iban_number: 'IBAN-nummer',
    without_supplier: 'Ohne Lieferant',
    price_in_euro: 'Preis VK',
    is_default: 'Voreinstellung',
    attribute_option: 'Attributoption',
    image: 'Bild',
    show_stats_user: 'Shop-Statistik – BENUTZER',
    shopUserStats: {
      pageTitle: 'Shop-Statistik – Benutzer',
      viewList: 'Statistik anzeigen',
      perPage: 'Zeilen pro Seite',
      searchPlaceholder: 'Suche nach E-Mail, Kundennummer, Firma…',
      paginationSummary: '{from}–{to} von {total} (Seite {page} / {lastPage})',
      loadError: 'Shop-Benutzerstatistik konnte nicht geladen werden.',
      exporting: 'Export läuft…',
      exportDone: 'Export abgeschlossen ({rows} Zeilen).',
      exportFailed: 'Export fehlgeschlagen.',
      exportPanel: {
        title: 'Excel-Export',
        refreshStatus: 'Status aktualisieren',
        lastExport: 'Letzter Export',
        lastPoint: 'Letzter Punkt',
        rowCount: 'Zeilen',
        stateReadyFresh: 'Daten sind aktuell. Sie können den Export herunterladen.',
        stateReadyStale:
          'Der Punktimport ist neuer als der letzte Export. Sie können die vorherige Datei herunterladen oder auf den nächsten Zyklus warten (alle 15 Min.).',
        stateWaitingRefresh: 'Neue Datei wird erstellt…',
        stateNoFile: 'Die Exportdatei ist noch nicht verfügbar.',
        firstFileEta: 'Erste Datei voraussichtlich um {eta}.',
        downloadExcel: 'Excel herunterladen',
        formatLabel: 'Format',
        formatXlsx: 'XLSX (.xlsx)',
        formatXls: 'XLS (.xls)',
        downloadLastFile: 'Letzte Datei herunterladen',
        waitForUpdate: 'Auf Aktualisierung warten',
        refreshInProgress: 'Aktualisierung läuft…',
        downloadSuccess: 'Datei heruntergeladen.',
        downloadUpdatedSuccess: 'Aktualisierte Datei heruntergeladen.',
        downloadRunning: 'Aktualisierung läuft, bitte versuchen Sie es in Kürze erneut.',
        downloadNotReady: 'Datei noch nicht bereit. Nächster Versuch um {eta}.',
        waitTimeout: 'Zeitüberschreitung beim Warten auf einen neuen Export.',
        statusLoadFailed: 'Exportstatus konnte nicht geladen werden.',
        staleConfirmTitle: 'Ältere Exportdatei herunterladen?',
        staleConfirmBody: 'Die Datei stammt vom {exportAt}, die Punkte wurden zuletzt am {pointAt} aktualisiert. Fortfahren?'
      }
    },
    is_manual_order: 'Ist eine manuelle Bestellung',
    supplier_id: 'Lieferant ID',
    vendor_id: 'Hersteller ID',
    archive_at: 'Archiv',
    exported_bridgestone: 'Exportiert Bridgestone',
    exported_engelbert: 'Exportiert Engelbert Strauss',
    exported_prime: 'Exportiert PrämieDirekt',
    exported_other: 'Andere exportiert',
    product_variant_id: 'Produktvarianten-ID',
    cancelled_at: 'Abgesagt um',
    shipped_at: 'Versand erfolgt am',
    product_id: 'Produkt-ID',
    quantity: 'Menge',
    qty: 'Menge',
    action_text: 'URL-Text',
    action_url: 'URL',
    token: 'UUID',
    marketing_option: 'Marketingoption',
    parent_id: 'Eltern ID',
    parent_name: 'Name des Elternteils',
    approval_id: 'Genehmigungs-ID',
    wholesaler_id: 'Wholesaler id',
    cart_id: 'Warenkorb-ID',
    order_date: 'Auftragsdatum',
    order_number: 'Bestellnummer',
    accept_date: 'Datum akzeptieren',
    wholesaler_dealer_id: 'Wholesaler dealer id',
    dealer_id: 'Dealer id',
    is_partial_delivery: 'Ist Teillieferung',
    order_completed: 'Bestellung abgeschlossen',
    order_cancelled: 'Bestellung storniert',
    date_delivery: 'Liefertermin',
    published: 'Veröffentlichen',
    properties: 'Eigenschaften',
    group: 'Gruppenname',
    gka: 'GKA',
    publish_at: 'Veröffentlichen',
    video: 'Video-URL',
    training_id: 'Training ID',
    correct: 'Ist richtig?',
    question_id: 'Frage-ID',
    body: 'Inhalt',
    size: 'Textgrösse',
    platform: 'Betriebssystem',
    is_added: 'Aktive Booster',
    numberOfSetsOfSeasonalTiresBudget: 'Einlagerungen pro Jahr',
    distributionWinter: 'Winter',
    distributionSummer: 'Sommer',
    overEighteenInch: 'Davon ≥ 18 Zoll (in %)',
    tireSalesNumber: 'Reifenumsatz pro Jahr ca. in Stk.',
    distributionAll: 'Alle seizoenen',
    budgetPremium: 'Premie',
    postal_code: 'Postleitzahl',
    legalForm: 'Rechtsform',
    budgetMid: 'Mid',
    budgetLow: 'Budget',
    group_id: 'Gruppen-ID',
    website: 'Webseite',
    customer_number: 'Kundennummer',
    user_id: 'Benutzer-ID',
    browser: 'Webbrowser',
    ip: 'IP Adresse',
    email_verified_at: 'E-Mail bestätigt unter',
    last_login: 'letzte Anmeldung',
    deleted_at: 'gelöscht am',
    is_active: 'Ist aktiv?',
    old: 'Alt',
    selectBooster: 'Booster auswählen',
    activeBooster: 'Aktiver Booster',
    activeBoosterText: 'Möchten Sie einen aktiven Booster für den Benutzer aktivieren?',
    activeBoostersOne: 'Werden Sie diesen Booster für jeden Benutzer aktivieren?',
    activeBoostersSalesDataWarning:
      'Bitte stellen Sie sicher, dass die Verkaufsdaten, die Sie boostern möchten, die endgültigen Verkaufszahlen sind und in Zukunft nicht mehr geändert werden. Andernfalls können Abweichungen in den Berechnungen auftreten. Diese Aktion kann nicht rückgängig gemacht werden.',
    sum: 'Summe',
    boosterOnTop: 'Booster-Punkte (zusätzlich)',
    relevantBoosterPoints: 'Relevante Punkte für Booster',
    totalBefore: 'Gesamtpunktzahl vorher',
    standardPoints: 'Standardpunkte',
    standard: 'Standard',
    boosterPoints: 'Booster-Punkte',
    allPoints: 'Alle punkte',
    pointsByUser: 'Laden Sie Punkte nach Benutzer herunter',
    pointsByGroup: 'Laden Sie Punkte nach Gruppe herunter',
    allKickbacks: 'Alle Kickbacks',
    kickbackByUser: 'Kickback nach Benutzer herunterladen',
    kickbackByGroup: 'Kickback nach Gruppe herunterladen',
    pointsImportFileInfo: 'In der Datei muss Spalte 1 die E-Mail und Spalte 2 die Punkte enthalten.',
    pointsImportHeaderInfo:
      'Die erste Zeile muss die Überschriften Email und Points enthalten. Die Daten beginnen ab der zweiten Zeile.',
    pointsImportValueInfo:
      'Die Punktewerte in der Datei müssen positiv oder negativ sein. Verwenden Sie positive Werte, um Punkte hinzuzufügen, und negative Werte, um Punkte abzuziehen.',
    pointsImportTitle: 'Punkte-Import aus Excel-Datei',
    pointsImportFailed: 'Import fehlgeschlagen',
    pointsImportSummaryTitle: 'Import-Zusammenfassung',
    pointsImportProcessed: 'Verarbeitet',
    pointsImportInvalidFile: 'Nur Excel-Dateien (.xlsx, .xls) sind erlaubt.',
    pointsImportPreviewLoading: 'Dateivorschau wird vorbereitet...',
    pointsImportPreviewCount: 'Es werden {shown} von {count} Zeilen aus der Datei angezeigt.',
    pointsImportPreviewEmpty: 'Die ausgewählte Datei enthält keine Zeilen zum Importieren.',
    pointsImportPreviewError: 'Die ausgewählte Excel-Datei konnte nicht gelesen werden.',
    pointsImportDateInfo:
      'Das ausgewählte Datum wird als Datum verwendet, an dem die Punkte auf dem Benutzerkonto entstehen. Es kann sich dabei auch um Punkte aus der Vergangenheit handeln.',
    loginAs: 'Melden Sie sich als Benutzer an',
    positionX: 'Position x',
    positionY: 'Position y',
    textSize: 'Textgrösse',
    text: 'Text',
    publish: 'Veröffentlichen',
    certificate: 'Zertifikat',
    certificatePdf: {
      title: 'ZERTIFIKAT',
      tookPartInCourse: 'hat am folgenden Kurs teilgenommen:',
      courseDetails: 'Kursdetails'
    },
    event: 'Event',
    remove_cs_number: 'Sind Sie sicher, dass Sie die Kundennummer {customerNumber} ({wholesaler}) löschen möchten?',
    keep_previous_year_points: 'Punkte aus den Vorjahren nach dem Löschen der Kundennummer behalten',
    keep_previous_year_points_warning:
      'If you select this option, deleting the customer number will remove only points from the current year. Points from previous years will remain, so older balances and reports may still include data linked to this customer number. Select this only if you want to keep past years unchanged.',
    remove_order: 'Sind Sie sicher, dass Sie die Bestellung löschen möchten?',
    is_internal: 'Ist interner Benutzer?',
    selectAddressBtn: 'Adresse auswählen',
    currentBasket: 'Aktueller Warenkorb',
    loginEmail: 'Anmeldung',
    tenantEmailType: 'E-Mail-Typ',
    tenantEmailAddNew: 'Neue E-Mail hinzufügen',
    tenantEmailTypeFinancial: 'Für finanzielle Informationen (u.a. Bonusspezifikation)',
    tenantEmailTypeMarketing: 'Für Bridgestone Plus Marketingkommunikation (u.a. Aktionen/Newsletter)',
    open_new_tab: 'In neuem Tab öffnen?',
    newTabLabel: 'Neuer Tab',
    file: 'Datei',
    company_name: 'Firma',
    partner_name: 'Ansprechpartnerin',
    dealer: 'Händler',
    boosterImport: {
      label: 'CSV Datei.'
    },
    created_at: 'Erstellt am',
    done_by: 'Ausgeführt von',
    authors: 'Ausgeführt von',
    changes: 'Änderungen',
    modified_user: 'Betroffener Benutzer',
    modified_users: 'Betroffene Benutzer',
    full_text_search: 'Volltextsuche',
    logs: 'Logs',
    activity: 'Aktivität',
    booster_create: 'Booster erstellen',
    booster_brands: 'Marken',
    booster_motor: 'Motorrad',
    booster_message_title: 'Nachrichtentitel',
    booster_delete_points: 'Punkte löschen',
    booster_delete_points_confirm:
      'Möchten Sie diese Booster-Punkte wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    booster_wholesaler: 'Wholesaler',
    booster_products: 'Produktnamen',
    booster_customers: 'Kundennummern',
    booster_saison: 'Saison',
    booster_name: 'Name',
    booster_factor: 'Faktor',
    booster_from: 'Laufzeit von',
    booster_to: 'Laufzeit bis',
    boosterList: {
      seasons: 'Saisons',
      usersAmount: 'Benutzeranzahl',
      factor: 'Faktor',
      calculateBoosters: 'Booster berechnen',
      calculateBoostersConfirmTitle: 'Booster berechnen?',
      calculateBoostersConfirm:
        'Dadurch wird die Berechnung der Booster-Punkte für passende Benutzer auf Basis dieser Booster-Konfiguration gestartet. Der Vorgang kann einige Zeit dauern. Die Ergebnisse erscheinen in der Booster-Vorschau, wo Sie sie prüfen und akzeptieren oder die berechneten Punkte löschen können. Nach Abschluss der Berechnung ist eine Bearbeitung dieses Boosters möglicherweise nicht mehr möglich. Möchten Sie fortfahren?',
      showAll: 'Alle anzeigen (+{count})',
      showLess: 'Weniger anzeigen'
    },
    booster_tires: 'Reifengrössen',
    booster_ipcs: 'IPCs',
    boosterIpcsImport: {
      button: 'IPCs aus Excel hochladen',
      hint: 'Spalte A, .xlsx/.xls-Datei',
      emptySheet: 'Leeres Arbeitsblatt.',
      emptyColumn: 'Keine Daten in Spalte A.',
      spacesError: 'Ungültige IPCs (enthalten Leerzeichen): {items}',
      invalidFormatError: 'Ungültiges IPC-Format (nur Zahlen): {items}',
      requestValidationError: 'Fehler bei der Request-Validierung.',
      unknownError: 'Unbekannte IPCs: {items}',
      success: 'IPCs importiert: {count}',
      readError: 'IPCs-Datei konnte nicht gelesen werden.'
    },
    select: 'Bitte Wählen',
    booking: 'Buchung',
    credit: 'Gutschrift',
    deduction: 'Abzug',
    preview: 'Vorschau',
    subject: 'Betreff',
    customerNumber: 'Kundennummer',
    search: 'Suchen',
    customer_nr_name: 'Kundennummer / Name',
    selectAll: 'Alle auswählen',
    deselectAll: 'Alle abwählen',
    generateReport: {
      selectAll: 'Alle auswählen',
      reset: 'Zurücksetzen',
      loadingInfo: 'Bericht wird erstellt, bitte warten...',
      generate: 'Erstellen',
      validation: {
        distributorRequired: 'Bitte wählen Sie mindestens einen Händler aus.'
      },
      personal_data: {
        title: 'Persönliche Daten',
        email: 'E-Mail',
        salutation: 'Anrede',
        first_name: 'Vorname',
        last_name: 'Nachname',
        job_position: 'Position'
      },
      shipping_address: {
        title: 'Lieferadresse',
        company: 'Firma',
        street: 'Strasse',
        postal_code: 'Postleitzahl',
        mobile_phone: 'Mobiltelefon',
        iban_number: 'IBAN',
        vat: 'MwSt.',
        city: 'Ort'
      },
      operating_data: {
        title: 'Betriebsdaten',
        customer_number: 'Kundennummer',
        group: 'Gruppe',
        first_registration: 'Erste Registrierung',
        last_login: 'Letzte Anmeldung',
        tires_per_year: 'Reifenumsatz pro Jahr',
        over_18_inch: 'Über 18 Zoll',
        premium: 'Premium',
        middle: 'Mittel',
        summer: 'Sommer',
        winter: 'Winter',
        all_season: 'Ganzjahresreifen',
        major: 'Marke'
      },
      calculated_data: {
        title: 'Berechnete Daten',
        tireAmount: 'Reifenmenge',
        points: 'Punkte',
        bonus: 'Bonus'
      },
      sales_structure: {
        title: 'Vertriebsstruktur',
        distributor: {
          title: 'Händler'
        },
        sales_representative: {
          title: 'Vertriebsmitarbeiter'
        },
        wholesaler: {
          title: 'Grosshändler'
        },
        dealer: {
          title: 'Autohaus'
        }
      },
      meta: {
        title: 'Filter',
        brand: {
          title: 'Marke',
          BS: 'BS',
          FS: 'FS'
        },
        year: {
          title: 'Jahr'
        },
        calendarMonth: {
          title: 'Monat',
          january: 'Januar',
          february: 'Februar',
          march: 'März',
          april: 'April',
          may: 'Mai',
          june: 'Juni',
          july: 'Juli',
          august: 'August',
          september: 'September',
          october: 'Oktober',
          november: 'November',
          december: 'Dezember'
        }
      }
    },
    import: 'Importieren',
    rows: 'Zeilen',
    message: 'Nachricht',
    articleNumber: 'Artikelnummer',
    inform_user: 'Kunden informieren',
    leaveComment: 'Hinterlasse hier einen Kommentar',
    user_new: 'Neuer Benutzer',
    postalcode: 'PLZ',
    city: 'Ort',
    residence: 'Ist Wohnsitz',
    country: 'Land',
    street: 'Strasse und Hausnummer',
    salutation: 'Anrede',
    suffix: 'Adresszusatz',
    emailVerified: 'E-Mail verifiziert am',
    registerAt: 'Registriert am',
    phone: 'Telefon',
    optinAt: 'OptIn am',
    fax: 'Fax',
    date: 'Datum',
    optinToken: 'OptIn-Token',
    language: 'Sprache',
    company: 'Firma',
    forename: 'Vorname',
    lastname: 'Nachname',
    title: 'Titel',
    subtitle: 'Untertitel',
    remove: 'Löschen',
    actions: 'Aktionen',
    userData: 'Benutzerdaten',
    clientType: 'Kundentyp',
    carDealer: 'Autohändler',
    tyreDealer: 'Reifenhändler',
    teamLkw: 'Team Lkw',
    teamEmOtr: 'Team EM/OTR',
    teamFarmTractor: 'Team Ackerschlepper',
    teamBandag: 'Team Bandag',
    chooseDots: 'Auswählen..',
    both: 'Beide',
    contact_service: {
      is_main: 'Isch Hauptkontakt?',
      direct: 'Direkt',
      indirect: 'Indirekt'
    },
    fileChoose: 'Datei auswählen',
    fileNoSelected: 'Keine Datei ausgewählt',
    loadingFile: 'Datei wird geladen...',
    only_points_payment: 'Nur Punktezahlung',
    column: 'Spalte',
    csvOnly: 'Nur CSV-Dateien sind erlaubt.',
    milestoneUsers: {
      csvImportTitle: 'CSV-Import',
      csvFormatHint: 'CSV-Format: <code>email,milestone</code> (Kopfzeile optional)',
      importErrorsTitle: 'Importfehler',
      errorLine: 'Zeile {line}: {message}',
      importFinished: 'CSV-Import abgeschlossen.'
    },
    kickbackPayoutReady: 'Formular bereit zum Senden. Ausgewählte Datei:',
    kickbackPayoutCsvInstruction: 'Die CSV-Datei muss zwei Spalten enthalten: erste mit E-Mail, zweite mit Bonuswert in EUR.',
    kickbackPayoutCsvHeaderInvalid:
      'Ungültiger CSV-Header. Erste Spalte muss Email sein, zweite im Format Bonus <Zahl> (z.B. Bonus 25).',
    kickbackPayoutCsvTwoColumnsOnly: 'CSV muss genau zwei Spalten enthalten: Email und Zahl.',
    kickbackPayoutCsvEmailNumberInvalid: 'Ungültige CSV-Daten. Erste Spalte muss eine E-Mail-Adresse sein, zweite eine Zahl.',
    kickbackPayoutCsvBonus: 'CSV-Bonus',
    kickbackPayoutKickBackFeeSum: 'Kickback-Summe',
    kickbackPayoutYear: 'Jahr',
    kickbackPayoutMissingEmails: 'Fehlende E-Mails:',
    kickbackPayoutCsvFile: 'CSV',
    kickbackPayoutCsvContent: 'CSV-Inhalt',
    kickbackPayoutAllTranslationsRaw: 'Alle Uebersetzungen (raw)',
    multiplicator: {
      goals: {
        loyal: 'Loyal',
        bronze: 'Bronze',
        silver: 'Silber',
        gold: 'Gold',
        platinum: 'Platin'
      }
    },
    importSchemaNotLoaded: 'Import-Schema ist nicht geladen.',
    csvHeaderEmpty: 'CSV-Header ist leer.',
    csvHeaderMismatch: 'CSV-Header stimmt in Spalte {index} nicht: erwartet "{expected}", erhalten "{actual}".',
    csvHeaderMismatchTitle: 'CSV-Header stimmt nicht überein',
    csvColumnCountMismatchTitle: 'CSV-Spaltenanzahl stimmt nicht',
    csvColumnCountMismatch: 'Zeile {row}: erwartet {expected} Spalten, erhalten {actual}.',
    csvHeaderColumnCountMismatch: 'Kopfzeile: erwartet {expected} Spalten, erhalten {actual}.',
    step: 'Schritt',
    profile: 'Profil',
    addresses: 'Adressen',
    address: 'Adresse',
    notAvailable: 'Zur Zeit nicht lieferbar',
    disabled: 'Deaktiviert',
    archived: 'Archiviert',
    visible_not_allowed_to_buy: 'Sichtbar, nicht kaufbar',
    isDefault: 'Voreinstellung',
    data: 'Daten',
    importText: 'Bitte wähle eine Datei zum Importieren aus:',
    importSchemaInfo: 'Die CSV-Datei muss die folgenden Felder in der unten angegebenen Reihenfolge enthalten.',
    importConfirm: 'Vorschau der CSV-Inhalte unten. Möchten Sie den Import fortsetzen?',
    importWholesalerHint: 'Optional. Wenn ausgewählt, werden Kundennummern aus der CSV diesem Grosshändler zugewiesen.',
    importDownloadTemplate: 'Leere CSV-Vorlage herunterladen',
    importModalTitle: 'Benutzer per CSV importieren',
    importStepSetup: 'Einrichtung',
    importStepPreview: 'Vorschau',
    importStepResult: 'Ergebnis',
    importStepHelper: 'Laden Sie die Vorlage herunter, tragen Sie Ihre Daten ein und laden Sie die CSV-Datei hoch.',
    importContextTitle: 'Importeinstellungen',
    importRowsInFile: '{count} Zeilen in der Datei',
    importValidating: 'Datei wird geprüft...',
    importPreviewLoading: 'Vorschau wird geladen...',
    importSubmitting: 'Benutzer werden importiert...',
    importStatsSuccess: 'Erfolg',
    importStatsError: 'Fehler',
    importStatsInfo: 'Info',
    importStatsOther: 'Sonstige',
    importShowSchema: 'Spaltenschema anzeigen',
    importHideSchema: 'Spaltenschema ausblenden',
    importPreviewChangesCount: '{count} Feldänderungen',
    importDropzoneTitle: 'CSV-Datei hier ablegen',
    importDropzoneHint: 'oder klicken, um eine Datei auszuwählen',
    importSelectClientTypeForPreview:
      'Datei sieht gültig aus ({count} Zeilen). Wählen Sie den Kundentyp, um die Vorschau zu laden.',
    importFileValid: 'Datei erfolgreich validiert ({count} Zeilen).',
    importLoadPreview: 'Vorschau laden',
    importPreviewFilterErrors: 'Fehler',
    importPreviewRowError: 'Fehler',
    importPreviewFailed: 'Importvorschau konnte nicht geladen werden.',
    importPreviewSummary: 'Zusammenfassung',
    importPreviewTotalRows: 'Zeilen gesamt',
    importPreviewNewUsers: 'Neue Benutzer',
    importPreviewUpdatedUsers: 'Aktualisierte Benutzer',
    importPreviewSkippedRows: 'Übersprungene Zeilen',
    importPreviewErrors: 'Fehler',
    importPreviewNewCustomerGroups: 'Neue Kundengruppen',
    importPreviewNewStaffUsers: 'Neue Vertriebsmitarbeiter',
    importPreviewAction: 'Aktion',
    importPreviewIncoming: 'Eingehend',
    importPreviewCreates: 'Erstellt',
    importPreviewUpdates: 'Aktualisiert',
    importPreviewFieldChanges: 'Feldänderungen',
    importPreviewFieldColumn: 'Feld',
    importPreviewCurrentValue: 'Aktuell',
    importPreviewFromFile: 'Aus Datei',
    importPreviewAfterImport: 'Nach Import',
    importPreviewNewValue: 'Neu',
    importPreviewWillChange: 'Wird geändert',
    importPreviewDiffersInFile: 'Weicht in Datei ab',
    importPreviewOnlyWithChanges: 'Nur Zeilen mit Änderungen',
    importPreviewFilterAll: 'Alle Zeilen',
    importPreviewShowDetails: 'Details',
    importPreviewBackToList: 'Zurück zur Liste',
    importPreviewHideDetails: 'Details ausblenden',
    importPreviewNoFilterResults: 'Keine Zeilen entsprechen den ausgewählten Filtern.',
    importPreviewRowDetails: 'Zeilendetails',
    importPreviewPlannedChanges: 'Geplante Änderungen',
    importPreviewExistingData: 'Aktuelle Daten im System',
    importPreviewFullComparison: 'Vollständiger Vergleich',
    importPreviewNoExistingData: 'Keine vorhandenen Daten (neuer Benutzer).',
    importPreviewNoFieldDetails: 'Für diese Zeile sind keine Felddetails verfügbar.',
    importPreviewCustomerGroups: 'Kundengruppen',
    importPreviewExistingCustomerGroups: 'Bestehende Gruppen',
    importPreviewActionCreate: 'Erstellen',
    importPreviewActionUpdate: 'Aktualisieren',
    importPreviewActionUnchanged: 'Unverändert',
    importPreviewActionSkip: 'Überspringen',
    importPreviewNoCreates: 'Es wird nichts Neues erstellt',
    importPreviewNoUpdates: 'Keine Felder werden aktualisiert',
    importPreviewNoRowDetails: 'Die Zusammenfassung ist verfügbar, aber die Zeilendetails konnten nicht geladen werden.',
    importPreviewDuplicateInFile: 'Duplikat in der Datei',
    importSuccess: 'Import erfolgreich abgeschlossen',
    importErrors: 'Importfehler',
    upload: 'Hochladen',
    users: 'Benutzer',
    permission: 'Recht',
    save: 'Speichern',
    saving: 'Speichern...',
    downloadOrderStats: 'Statistiken herunterladen',
    downloadProductStats: 'Download Produktstatistiken herunter',
    category: 'Kategorie',
    order: 'Bestellung',
    permissions: 'Rechte',
    edit_permissions_title: 'Berechtigungen bearbeiten',
    options: 'Optionen',
    attributes: 'Attribute',
    add_attribute: 'Attribute hinzufügen',
    login: 'Einloggen',
    logout: 'Ausloggen',
    email: 'E-Mail',
    username: 'Benutzer',
    filter: 'Filtern',
    name: 'Name',
    points: 'Punkte',
    sku: 'SKU',
    count: 'Anzahl',
    action: 'Aktion',
    active: 'Aktiv',
    activeLabel: 'Aktiv',
    type: 'Typ',
    status: 'Zustand',
    main: 'Hauptprodukt',
    vendor: 'Hersteller',
    supplier: 'Lieferant',
    variant: 'Produktvariante',
    description: 'Beschreibung',
    short_description: 'Kurzbeschreibung',
    upload_text: 'Produktbilder-Upload',
    product_new: 'Neues Einzel-Produkt',
    product_new_variants: 'Neues Varianten-Produkt',
    training_new: 'Neues Training',
    btraining_new: 'Neues BS Schulunge',
    images: 'Bilder',
    roles: 'Rollen',
    search_products: 'Produktsuche',
    search_orders: 'Aufträge durchsuchen',
    search_type: 'Suchtyp',
    hunter_new: 'Neuer Werkstatteinrichtungen',
    first_name: 'Vorname',
    last_name: 'Nachname',
    social_security_number: 'Sozialversicherungsnummer',
    place_of_birth: 'Geburtsort',
    date_of_birth: 'Geburtsdatum',
    copy: 'Kopieren',
    add_empty_variant: 'Leere Variante hinzufügen',
    points_exporter_users_with_available_points: 'Benutzer mit verfügbaren Punkten',
    points_exporter_unlocked_points: 'Export von Benutzern mit freigeschalteten Punkten',
    points_exporter_date_label: 'Datum',
    start_date: 'Startdatum',
    end_date: 'Enddatum',
    points_exporter_download_button: 'Excel herunterladen',
    menu: {
      customerGroup: {
        new: 'Neue Kundengruppe',
        list: 'Kundengruppenliste'
      },
      shopLimits: 'Shop limits',
      default_banners: 'Default banners',
      import_adex: 'Adex import',
      adex: 'Adex',
      logs: 'Logs',
      activities: 'Aktivitäten',
      booster_setup: 'Booster einrichten',
      booster_list: 'List',
      customer: 'Kunden',
      'users-roles': 'Benutzerverwaltung',
      roles: 'Rollen',
      booster: 'Booster',
      cheques: 'Schecks & Abzüge',
      points: 'Punkteverwaltung',
      users: 'Benutzer',
      users_list: 'Benutzerliste',
      milestone_users: 'Milestone Nutzer',
      shop_user_stats_list: 'Shop-Benutzerstatistik',
      user_new: 'Neuer Benutzer',
      users_deleted: 'Gelöschte Benutzer',
      perms: 'Rechte',
      'products-categories': 'Prämienshop',
      categories: 'Kategorien',
      categories_list: 'Kategorienliste',
      category_new: 'Neue Kategorie',
      orders: 'Bestellungen',
      products: 'Produkte',
      products_list: 'Produktliste',
      product_new: 'Neues Einzel-Produkt',
      product_new_variants: 'Neues Varianten-Produkt',
      attributes: 'Attribute',
      attributes_list: 'Liste der Attribute',
      attribute_new: 'New Attribute',
      options: 'Optionen',
      options_list: 'Optionsliste',
      options_new: 'Neue Option',
      vendors: 'Hersteller',
      vendors_list: 'Herstellerliste',
      vendor_new: 'Neuer Hersteller',
      suppliers: 'Lieferanten',
      suppliers_list: 'Lieferantenliste',
      supplier_new: 'Neuer Lieferant',
      sliders: 'Main Teaser Slider',
      sliders_list: 'Liste',
      slider_new: 'Neuer Main Teaser Slider',
      featured: 'Teaser Produkte',
      commands: 'Befehle',
      command_ipc: 'IPC',
      command_users: 'Benutzer importieren',
      'trainings-schulungen': 'Trainings & Schulungen',
      trainings: 'Online Trainings',
      trainings_list: 'Liste',
      training_new: 'Neue hinzufügen',
      btrainings: 'BS Schulungen',
      btrainings_list: 'Liste',
      btraining_new: 'Neue hinzufügen',
      management: 'Inhaltsverwaltung',
      textpages: 'Textseiten',
      textpages_list: 'Liste',
      text_page_new: 'Neue hinzufügen',
      marketing_consents: 'Marketing-Zustimmungen',
      marketing_consents_list: 'Liste',
      marketing_consents_edit: 'Marketing-Zustimmung bearbeiten',
      settings: 'Nachrichten-Manager',
      messages: 'Nachrichten anlegen',
      messages_list: 'Liste',
      messages_new: 'Neue hinzufügen',
      threads: 'Autom. Mails einrichten',
      requests: 'Benutzeranfragen',
      product_trainings_request: 'Online Trainings',
      bridgestone_courses_request: 'BS Schulungen',
      external_trainings_request: 'Externe Schulungen',
      hunter_request: 'Werkstatteinrichtungen',
      investments_request: 'Investitionsunterstützung',
      news_feed: 'Neuigkeiten',
      news_feed_list: 'Liste',
      news_feed_new: 'Neue hinzufügen',
      salespromotions: 'Verkaufsförderung',
      promotions: 'Promotions',
      promotions_list: 'Liste',
      promotions_new: 'Neu',
      imported_products: 'Importierte Produkte',
      ipcs_list: 'IPC-Liste',
      hunter_list: 'Liste',
      hunters: 'Werkstatteinrichtungen',
      hunter_new: 'Neuer Werkstatteinrichtungen',
      groups: 'Gruppen',
      groups_list: 'Gruppenliste',
      parent_attributes: 'Übergeordnete Attribute',
      group_new: 'Neue Gruppe',
      history: 'Anmeldeverlauf',
      history_list: 'Anmeldeverlauf',
      prices: 'Pricat',
      prices_list: 'Liste',
      price_new: 'Neue Pricat',
      price_categories: 'Preislisten',
      price_categories_list: 'Liste',
      price_categories_new: 'Neue Preislisten',
      inactive_users: 'Neuanmeldungen<br/>freigeben',
      customer_numbers_to_approve: 'Neuanmeldungen<br/>ohne Nummer',
      complaints: 'Beanstandungsformular',
      orders_list: 'Liste',
      orders_new: 'Neue Bestellungen',
      points_list: 'Punkteliste',
      kickback_list: 'Kickback fee',
      kickback_payout: 'Kickback Auszahlung',
      booster_preview: 'Vorschau',
      frontend_menu: 'Frontend-Menü',
      frontend_menu_list: 'Liste',
      frontend_menu_new: 'Neue',
      'customer-groups': 'Kundengruppen',
      'customer-groups-list': 'Kundengruppenliste',
      'customer-groups-new': 'Neue Kundengruppe',
      'customer-groups-edit': 'Kundengruppe bearbeiten',
      customer_group_new: 'Neue Kundengruppe',
      mediapages: 'Medienbibliothek',
      mediapages_list: 'Liste',
      media_page_new: 'Neu',
      uberall_request: 'Uberall',
      history_hour: 'Anmeldezeiten',
      wholesaler_management: 'Wholesaler management',
      in_active_cs_nr: 'Deaktiviert Nummern',
      mediapages_file_list: 'Dateiliste',
      vouchers: 'Vouchers',
      vouchers_list: 'List',
      vouchers_new: 'Neu',
      brochure_prices_list: 'Liste',
      brochure_prices: 'Broschüren & Preislisten',
      brochure_prices_new: 'Neu',
      brochure_file_list: 'Dateiliste',
      main_boxes: 'Teaser Boxes',
      main_boxes_list: 'Liste',
      main_box: 'Bearbeiten',
      main_boxes_new: 'Neu',
      'hello-customer-survey': 'Hello-Kundenumfrage',
      apps: 'Anwendungen',
      apps_list: 'Liste der Anwendungen',
      dealer_apps: 'Dealer-Apps',
      contact_service: 'Kontaktservice',
      contact_service_list: 'Liste',
      contact_service_new: 'Neu',
      contact_service_edit: 'Bearbeiten',
      points_exporter: 'Points Exporter',
      points_exporter_export: 'Export',
      customer_numbers_assistant: 'Nummern Assistent',
      about: 'Über-uns-Seite',
      about_list: 'Liste',
      about_new: 'Neu',
      about_edit: 'Bearbeiten'
    },
    breadcrumb: {
      shopLimits: 'Shop limits',
      customer_numbers_assistant: 'Nummern Assistent',
      in_active_cs_nr: 'Deaktiviert Nummern',
      default_banners: 'Default banners',
      import_adex: 'Adex import',
      adex: 'Adex',
      activities: 'Aktivitäten',
      booster_setup: 'Booster einrichten',
      booster_list: 'List',
      customer: 'Kunden',
      booster: 'Booster',
      booster_edit: 'Bearbeiten',
      cheques: 'Schecks & Abzüge',
      user_edit: 'Benutzer bearbeiten',
      users: 'Benutzer',
      user: 'Benutzer',
      vendors: 'Hersteller',
      vendor_new: 'Neuer Hersteller',
      suppliers: 'Lieferanten',
      supplier_new: 'neuer Lieferant',
      home: 'Home',
      perms: 'Rechte',
      roles: 'Rollen',
      roles_list: 'Liste',
      dashboard: 'Dashboard',
      orders: 'Bestellungen',
      orders_edit: 'Bestellung bearbeiten',
      orders_view: 'Bestellung',
      orders_list: 'Liste',
      salespromotions: 'Verkaufsförderung',
      promotions: 'Promotions',
      promotions_list: 'Liste',
      promotions_new: 'Neu',
      promotions_edit: 'Bearbeiten',
      salespromotions_list: 'Liste',
      salespromotions_view: 'Sicht',
      categories: 'Kategorien',
      categories_list: 'Liste',
      role: 'Rolle',
      category: 'Kategorie',
      marketing_consents: 'Marketing-Zustimmungen',
      marketing_consents_list: 'Liste',
      marketing_consents_edit: 'Marketing-Zustimmung bearbeiten',
      products: 'Produkte',
      products_list: 'Liste',
      product: 'Produkt',
      product_category: 'Kategorie-Produkte',
      product_new: 'Neues Einzel-Produkt',
      product_new_variants: 'Neues Varianten-Produkt',
      product_variants: 'Varianten-Produkt',
      attributes: 'Attribute',
      attributes_list: 'Liste',
      attribute: 'Attribut',
      category_new: 'Neue Kategorie',
      attribute_edit: 'Attribut bearbeiten',
      options_new: 'Neue Option',
      options: 'Optionen',
      options_list: 'Liste',
      options_edit: 'Option bearbeiten',
      userEdit: 'Benutzer bearbeiten',
      users_list: 'Liste',
      milestone_users: 'Milestone Nutzer',
      shop_user_stats_list: 'Shop-Benutzerstatistik',
      users_deleted: 'Gelöschte Benutzer',
      vendor_edit: 'Hersteller bearebiten',
      vendors_list: 'Liste',
      supplier_edit: 'Lieferant bearbeiten',
      suppliers_list: 'Lieferantenliste',
      user_new: 'Neuer Benutzer',
      trainings: 'Trainings',
      trainings_list: 'Liste',
      btrainings: 'Online-Trainings',
      btrainings_list: 'Liste',
      btraining: 'Online-Trainings',
      training_new: 'Neues Training',
      btraining_new: 'Neues BS Schulunge',
      training_edit: 'Training bearbeiten',
      training: 'Training',
      command_ipc: 'IPC',
      sliders: 'Main Teaser Slider',
      sliders_list: 'Liste',
      slider_new: 'Neuer Main Teaser Slider',
      slider: 'Main Teaser Slider bearbeiten',
      command_users: 'Benutzer Importieren',
      textpages: 'Textseiten',
      text_page_new: 'Neue Textseite',
      textpage: 'Textseiten',
      textpages_list: 'Liste',
      messages: 'Nachrichten',
      messages_list: 'Liste',
      messages_new: 'Neue Nachricht',
      messages_edit: 'Nachricht bearbeiten',
      threads: 'Betreff',
      featured: 'Teaser Produkte',
      attribute_new: 'Neues Attribut',
      product_trainings_request: 'Anfragen zu Online Trainings',
      bridgestone_courses_request: 'Anfragen zu Bridgestone-Schulungen',
      external_trainings_request: 'Anfragen zu externen Schulungen',
      hunter_request: 'Werkstatteinrichtungen',
      investments_request: 'Investitionsunterstützung',
      news_feed: 'Neuigkeiten',
      news_feed_list: 'Liste',
      news_feed_new: 'Neuer Newsfeed',
      news_feed_edit: 'Newsfeed bearbeiten',
      news_feed_slider: 'Neuer Newsfeed-Slider',
      content: 'Inhalt',
      imported_products: 'Importierte Produkte',
      ipcs_list: 'IPC-Liste',
      hunter_list: 'Liste',
      hunters: 'Werkstatteinrichtungen',
      hunter_new: 'Neuer Werkstatteinrichtungen',
      hunter_edit: 'Werkstatteinrichtungen bearbeiten',
      groups: 'Gruppen',
      groups_list: 'Gruppenliste',
      parent_attributes: 'Übergeordnete Attribute',
      group_new: 'Neue Gruppe',
      group_edit: 'Gruppe Bearbeiten',
      history: 'Anmeldeverlauf',
      history_list: 'Anmeldeverlauf',
      history_view: 'Benutzer-Anmeldeverlauf',
      prices: 'Pricat',
      prices_list: 'Liste',
      price_new: 'Neue Pricat',
      price: 'Pricat bearbeiten',
      price_categories: 'Preisliste',
      price_categories_list: 'Liste',
      price_categories_new: 'Neue Preislisten',
      price_category: 'Preisliste',
      inactive_users: 'Neuanmeldungen freigeben',
      inactive_users_list: 'Liste',
      customer_numbers_to_approve: 'Neuanmeldungen ohne Nummer',
      complaints: 'Beanstandungsformular',
      complaints_list: 'Liste',
      complaints_view: 'Beschwerde',
      orders_new: 'Neue Bestellungen',
      points_list: 'Punkteliste',
      kickback_list: 'Kickback fee',
      kickback_payout: 'Kickback Auszahlung',
      booster_preview: 'Vorschau',
      frontend_menu: 'Frontend-Menü',
      frontend_menu_list: 'Liste',
      frontend_menu_new: 'Neue',
      'customer-groups': 'Kundengruppen',
      'customer-groups-list': 'Kundengruppenliste',
      'customer-groups-new': 'Neue Kundengruppe',
      mediapages: 'Medienbibliothek',
      mediapages_list: 'Liste',
      media_page_new: 'Neu',
      mediapage: 'Bearbeiten',
      uberall_request: 'Uberall',
      history_hour: 'Anmeldezeiten',
      wholesaler_management: 'Wholesaler management',
      in_active_cs_nr: 'Deaktiviert Nummern',
      mediapages_file_list: 'Dateiliste',
      vouchers: 'Vouchers',
      vouchers_list: 'List',
      vouchers_new: 'Neu',
      brochure_prices_list: 'Liste',
      brochure_file_list: 'Dateiliste',
      brochure_prices: 'Broschüren & Preislisten',
      brochure_prices_new: 'Neu',
      main_boxes: 'Teaser Boxes',
      main_boxes_list: 'Liste',
      main_box: 'Bearbeiten',
      main_boxes_new: 'Neu',
      'hello-customer-survey': 'Hello-Kundenumfrage',
      apps_list: 'Liste der Anwendungen',
      app_new: 'Neu',
      app: 'Bearbeiten',
      about: 'Über-uns-Seite',
      about_list: 'Liste',
      about_new: 'Neu',
      about_edit: 'Bearbeiten',
      contact_service: 'Kontaktservice',
      contact_service_list: 'Liste',
      contact_service_new: 'Neu',
      contact_service_edit: 'Bearbeiten',
      contact_service_description_list: 'Lischt vo de Kontaktservice-Beschriebe',
      contact_service_description_edit: 'Kontaktservice-Beschribig bearbeite',
      contact_service_description_new: 'Neui Kontaktservice-Beschribig',
      points_exporter: 'Points Exporter',
      points_exporter_export: 'Export'
    },
    orders: {
      view: 'Bestellung',
      new: 'Neue Bestellung',
      list: 'Bestellungen',
      edit: 'Bestellung bearbeiten',
      number: 'Bestellnummer',
      date: 'Bestelldatum',
      state: 'Bestellstatus',
      labels: {
        company: 'Firma',
        name: 'Name',
        street: 'Strasse',
        postalCodeCity: 'PLZ / Ort',
        userPhone: 'Telefon (Benutzer)',
        userEmail: 'E-Mail (Benutzer)',
        orderPhone: 'Telefon (Bestellung)'
      },
      status: {
        created: 'Erstellt',
        confirm_order: 'Bestellung bestätigen',
        ready_for_shipment: 'Versandfertig',
        rejected: 'Abgelehnt',
        processed: 'Verarbeitet',
        shipped: 'Versendet',
        returned: 'Ist zurückgekommen',
        finished: 'Fertig',
        deleted: 'Gelöscht'
      },
      cartQuantityIncreased: 'Die Produktmenge im Warenkorb wurde erhöht.',
      cartQuantityDecreased: 'Die Produktmenge im Warenkorb wurde verringert.',
      confirmIncreaseItem: 'Möchten Sie die Menge dieses Produkts in der Bestellung wirklich erhöhen?',
      confirmDecreaseItem: 'Möchten Sie die Menge dieses Produkts in der Bestellung wirklich verringern?',
      confirmDeleteItem: 'Möchten Sie dieses Produkt wirklich aus der Bestellung entfernen?',
      deletedInfo: 'Diese Bestellung wurde am {date} gelöscht',
      activityLogs: 'Änderungshistorie',
      quantityChanged: 'Menge: {from} → {to}',
      itemRemoved: 'Nicht lieferbar / entfernt'
    },
    salespromotions: {
      view: 'Verkaufsförderung',
      list: 'Verkaufsförderungen',
      premium: 'DRIVEOURBEST',
      guarantee: 'TYREPROTECT',
      bonusCampaign: 'REIFENHITS',
      advantage: 'VORTEILSAKTION'
    },
    countries: {
      ad: 'Andorra',
      ae: 'Vereinigte Arabische Emirate',
      af: 'Afghanistan',
      ag: 'Antigua und Barbuda',
      ai: 'Anguilla',
      al: 'Albanien',
      am: 'Armenien',
      ao: 'Angola',
      aq: 'Antarktis',
      ar: 'Argentinien',
      as: 'Amerikanisch-Samoa',
      at: 'Österreich',
      au: 'Australien',
      aw: 'Aruba',
      ax: 'Ålandinseln',
      az: 'Aserbaidschan',
      ba: 'Bosnien und Herzegowina',
      bb: 'Barbados',
      bd: 'Bangladesch',
      be: 'Belgien',
      bf: 'Burkina Faso',
      bg: 'Bulgarien',
      bh: 'Bahrain',
      bi: 'Burundi',
      bj: 'Benin',
      bl: 'St. Barthélemy',
      bm: 'Bermuda',
      bn: 'Brunei Darussalam',
      bo: 'Bolivien',
      bq: 'Karibische Niederlande',
      br: 'Brasilien',
      bs: 'Bahamas',
      bt: 'Bhutan',
      bv: 'Bouvetinsel',
      bw: 'Botsuana',
      by: 'Belarus',
      bz: 'Belize',
      ca: 'Kanada',
      cc: 'Kokosinseln',
      cd: 'Kongo-Kinshasa',
      cf: 'Zentralafrikanische Republik',
      cg: 'Kongo-Brazzaville',
      ch: 'Schweiz',
      ci: 'Côte d’Ivoire',
      ck: 'Cookinseln',
      cl: 'Chile',
      cm: 'Kamerun',
      cn: 'China',
      co: 'Kolumbien',
      cr: 'Costa Rica',
      cu: 'Kuba',
      cv: 'Cabo Verde',
      cw: 'Curaçao',
      cx: 'Weihnachtsinsel',
      cy: 'Zypern',
      cz: 'Tschechien',
      de: 'Deutschland',
      dj: 'Dschibuti',
      dk: 'Dänemark',
      dm: 'Dominica',
      do: 'Dominikanische Republik',
      dz: 'Algerien',
      ec: 'Ecuador',
      ee: 'Estland',
      eg: 'Ägypten',
      eh: 'Westsahara',
      er: 'Eritrea',
      es: 'Spanien',
      et: 'Äthiopien',
      fi: 'Finnland',
      fj: 'Fidschi',
      fk: 'Falklandinseln',
      fm: 'Mikronesien',
      fo: 'Färöer',
      fr: 'Frankreich',
      ga: 'Gabun',
      gb: 'Vereinigtes Königreich',
      gd: 'Grenada',
      ge: 'Georgien',
      gf: 'Französisch-Guayana',
      gg: 'Guernsey',
      gh: 'Ghana',
      gi: 'Gibraltar',
      gl: 'Grönland',
      gm: 'Gambia',
      gn: 'Guinea',
      gp: 'Guadeloupe',
      gq: 'Äquatorialguinea',
      gr: 'Griechenland',
      gs: 'Südgeorgien und die Südlichen Sandwichinseln',
      gt: 'Guatemala',
      gu: 'Guam',
      gw: 'Guinea-Bissau',
      gy: 'Guyana',
      hk: 'Sonderverwaltungsregion Hongkong',
      hm: 'Heard und McDonaldinseln',
      hn: 'Honduras',
      hr: 'Kroatien',
      ht: 'Haiti',
      hu: 'Ungarn',
      id: 'Indonesien',
      ie: 'Irland',
      il: 'Israel',
      im: 'Isle of Man',
      in: 'Indien',
      io: 'Britisches Territorium im Indischen Ozean',
      iq: 'Irak',
      ir: 'Iran',
      is: 'Island',
      it: 'Italien',
      je: 'Jersey',
      jm: 'Jamaika',
      jo: 'Jordanien',
      jp: 'Japan',
      ke: 'Kenia',
      kg: 'Kirgisistan',
      kh: 'Kambodscha',
      ki: 'Kiribati',
      km: 'Komoren',
      kn: 'St. Kitts und Nevis',
      kp: 'Nordkorea',
      kr: 'Südkorea',
      kw: 'Kuwait',
      ky: 'Kaimaninseln',
      kz: 'Kasachstan',
      la: 'Laos',
      lb: 'Libanon',
      lc: 'St. Lucia',
      li: 'Liechtenstein',
      lk: 'Sri Lanka',
      lr: 'Liberia',
      ls: 'Lesotho',
      lt: 'Litauen',
      lu: 'Luxemburg',
      lv: 'Lettland',
      ly: 'Libyen',
      ma: 'Marokko',
      mc: 'Monaco',
      md: 'Republik Moldau',
      me: 'Montenegro',
      mf: 'St. Martin',
      mg: 'Madagaskar',
      mh: 'Marshallinseln',
      mk: 'Nordmazedonien',
      ml: 'Mali',
      mm: 'Myanmar',
      mn: 'Mongolei',
      mo: 'Sonderverwaltungsregion Macau',
      mp: 'Nördliche Marianen',
      mq: 'Martinique',
      mr: 'Mauretanien',
      ms: 'Montserrat',
      mt: 'Malta',
      mu: 'Mauritius',
      mv: 'Malediven',
      mw: 'Malawi',
      mx: 'Mexiko',
      my: 'Malaysia',
      mz: 'Mosambik',
      na: 'Namibia',
      nc: 'Neukaledonien',
      ne: 'Niger',
      nf: 'Norfolkinsel',
      ng: 'Nigeria',
      ni: 'Nicaragua',
      nl: 'Niederlande',
      no: 'Norwegen',
      np: 'Nepal',
      nr: 'Nauru',
      nu: 'Niue',
      nz: 'Neuseeland',
      om: 'Oman',
      pa: 'Panama',
      pe: 'Peru',
      pf: 'Französisch-Polynesien',
      pg: 'Papua-Neuguinea',
      ph: 'Philippinen',
      pk: 'Pakistan',
      pl: 'Polen',
      pm: 'St. Pierre und Miquelon',
      pn: 'Pitcairninseln',
      pr: 'Puerto Rico',
      ps: 'Palästinensische Autonomiegebiete',
      pt: 'Portugal',
      pw: 'Palau',
      py: 'Paraguay',
      qa: 'Katar',
      re: 'Réunion',
      ro: 'Rumänien',
      rs: 'Serbien',
      ru: 'Russland',
      rw: 'Ruanda',
      sa: 'Saudi-Arabien',
      sb: 'Salomonen',
      sc: 'Seychellen',
      sd: 'Sudan',
      se: 'Schweden',
      sg: 'Singapur',
      sh: 'St. Helena',
      si: 'Slowenien',
      sj: 'Spitzbergen und Jan Mayen',
      sk: 'Slowakei',
      sl: 'Sierra Leone',
      sm: 'San Marino',
      sn: 'Senegal',
      so: 'Somalia',
      sr: 'Suriname',
      ss: 'Südsudan',
      st: 'São Tomé und Príncipe',
      sv: 'El Salvador',
      sx: 'Sint Maarten',
      sy: 'Syrien',
      sz: 'Eswatini',
      tc: 'Turks- und Caicosinseln',
      td: 'Tschad',
      tf: 'Französische Süd- und Antarktisgebiete',
      tg: 'Togo',
      th: 'Thailand',
      tj: 'Tadschikistan',
      tk: 'Tokelau',
      tl: 'Timor-Leste',
      tm: 'Turkmenistan',
      tn: 'Tunesien',
      to: 'Tonga',
      tr: 'Türkei',
      tt: 'Trinidad und Tobago',
      tv: 'Tuvalu',
      tw: 'Taiwan',
      tz: 'Tansania',
      ua: 'Ukraine',
      ug: 'Uganda',
      uk: 'Vereinigtes Königreich',
      um: 'Amerikanische Überseeinseln',
      us: 'Vereinigte Staaten',
      uy: 'Uruguay',
      uz: 'Usbekistan',
      va: 'Vatikanstadt',
      vc: 'St. Vincent und die Grenadinen',
      ve: 'Venezuela',
      vg: 'Britische Jungferninseln',
      vi: 'Amerikanische Jungferninseln',
      vn: 'Vietnam',
      vu: 'Vanuatu',
      wf: 'Wallis und Futuna',
      ws: 'Samoa',
      xk: 'Kosovo',
      ye: 'Jemen',
      yt: 'Mayotte',
      za: 'Südafrika',
      zm: 'Sambia',
      zw: 'Simbabwe'
    },
    messages: {
      list: 'Nachrichten',
      new: 'Neue Nachricht',
      edit: 'Nachricht bearbeiten',
      title: 'Titel',
      content: 'Inhalt',
      empty: 'Keine Nachrichten',
      direct: 'Direktnachricht',
      toDealers: 'An Händler',
      sendEmail: 'E-Mail senden',
      selectWholesalers: 'Grosshändler auswählen',
      directWholesaler: 'vom Grosshändler zum Händler',
      selectGroups: 'Gruppen auswählen',
      directGroup: 'An Händlergruppen',
      toGroups: 'An Gruppen',
      saveAndSend: 'Speichern und senden',
      users: 'Benutzer auswählen (min. 3 Zeichen)',
      sent: 'Gesendet',
      externalTrainingPoints: 'Externe Training / Investitionsunterstützung Punkte',
      externalTrainingBank: 'Externe Training / Investitionsunterstützung Kontoinhaber',
      externalTrainingIBAN: 'Externe Training / Investitionsunterstützung IBAN',
      onlineTrainingTitle: 'Online Training - Titel',
      onlineTrainingPoints: 'Online Training - Punkte',
      hunterTitle: 'Werkstatteinrichtungen - Titel',
      hunterPoints: 'Werkstatteinrichtungen - Punkte',
      hunterPrice: 'Werkstatteinrichtungen - Preis',
      bTrainingTitle: 'Bridgestone Schulungen - Titel',
      bTrainingPoints: 'BS Schulungen - Points',
      pointsProfileComplete: 'Punkte - Profil vervollständigt',
      orderProducts: 'Produkte in der Bestellung'
    },
    messages_alert: {
      title: 'Nachright löschen',
      desc: 'Möchten Sie die Nachricht wirklich löschen?'
    },
    groups_alert: {
      title: 'Gruppe löschen',
      desc: 'Möchten Sie die Gruppe wirklich löschen?'
    },
    vendors_alert: {
      title: 'Hersteller löschen',
      desc: 'Möchten Sie den Hersteller wirklich löschen?'
    },
    suppliers_alert: {
      title: 'Lieferant löschen',
      desc: 'Möchten Sie den Lieferanten wirklich löschen?'
    },
    threads: {
      title: 'Betreff',
      choose: 'Bitte Nachricht auswählen',
      order: 'Betreff für Bestellungen auswählen',
      salespromotions: 'Betreff für Verkaufsförderung auswählen',
      externalTraining: 'Betreff für Externe Schulungen auswählen',
      investment: 'Betreff für investitionsunterstützung',
      onlineTraining: 'Betreff für Online Training',
      hunter: 'Betreff für Werkstatteinrichtungen',
      bTraining: 'Betreff für Bridgestone Schulungen',
      profileComplete: 'Betreff für Profilvervollständigung',
      activeUser: 'Aktive Benutzernachricht'
    },
    userGroup: {
      parentAttributeName: 'Übergeordnetes Attribut',
      name: 'Gruppenname',
      gka: 'GKA',
      isMain: 'Ist übergeordnet?',
      dealersGroupTab: 'Händlergruppe',
      dealersTab: 'Händler',
      searchDealers: 'Händler suchen'
    },
    customerGroup: {
      name: 'Name der Kundengruppe'
    },
    role: 'Rolle',
    user: 'Benutzer',
    vat: 'Steuernummer',
    categories: 'Kategorien',
    count_users: 'Anzahl Benutzer',
    product: 'Produkt',
    count_perms: 'Anzahl Rechte',
    count_products: 'Anzahl Produkte',
    count_files: 'Anzahl Dateien',
    count_options: 'Anzahl Optionen',
    attribute_new: 'Neues Attribut',
    category_new: 'Neue Kategorie',
    category_title: 'Kategorietitel',
    category_desc: 'Kategorie beschreibung',
    category_image: 'Kategorie Bild',
    category_link: 'Kategorie Link',
    category_alert: {
      title: 'Kategorie löschen',
      desc: 'Möchten Sie die Kategorie wirklich löschen?'
    },
    text_page_alert: {
      title: 'Textseite löschen',
      desc: 'Möchten Sie die Textseite wirklich löschen?'
    },
    news_feed_alert: {
      title: 'Newsfeed löschen',
      desc: 'Möchten Sie den Newsfeed "{title}" wirklich löschen?'
    },
    newsFeedList: {
      perPage: 'Einträge pro Seite',
      loading: 'Newsfeeds werden geladen…',
      paginationSummary: '{from}–{to} von {total} (Seite {page} / {lastPage})',
      moveUp: 'Nach oben',
      moveDown: 'Nach unten'
    },
    ipcList: {
      title: 'IPC-Liste',
      perPage: 'Zeilen pro Seite',
      clearFilters: 'Filter zurücksetzen',
      loading: 'IPCs werden geladen…',
      accessDenied: 'Sie haben keine Berechtigung, die IPC-Liste anzuzeigen.',
      paginationSummary: '{from}–{to} von {total}',
      columns: {
        material: 'Material / IPC',
        detailed_brand: 'Detaillierte Marke',
        tyre_size_designation: 'Reifengröße',
        new_budget_category: 'Budgetkategorie',
        service_description: 'Servicebeschreibung',
        rim: 'Felge',
        marketing_product_brand: 'Marketing-Marke',
        marketing_product_name: 'Marketing-Produktname'
      }
    },
    slider_alert: {
      title: 'Slider löschen',
      desc: 'Möchten Sie den Slider "{title}" wirklich löschen?'
    },
    question_alert: {
      title: 'Delete Question',
      desc: 'Do you really want to delete the question?'
    },
    certificate_alert: {
      title: 'Delete Certificate Text',
      desc: 'Do you really want to delete the certificate text?'
    },
    product_alert: {
      title: 'Produkt löschen',
      desc: 'Möchten Sie das Produkt wirklich löschen?'
    },
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    options_new: 'Neue Option',
    subcategory: 'Unterkategorie',
    uploadText: 'Ein Bild hochladen',
    startImport: 'Import starten',
    importStarted: 'Import wurde gestartet',
    connection: 'Verbindung',
    variants: 'Varianten',
    add_variant: 'Variante hinzufügen',
    vendor_new: 'Neuer Hersteller',
    training_edit: 'Training bearbeiten',
    vendors: 'Hersteller',
    supplier_new: 'Neuer Lieferant',
    suppliers: 'Lieferanten',
    training: 'Training',
    commands: {
      ipc: 'IPC-Importer',
      users: 'Benutzer Importieren'
    },
    userImport: {
      label: 'Nur XLSX-Typ'
    },
    questions: 'Fragen',
    correctAnswer: 'Richtige Antwort',
    validation: {
      required: 'Field is required'
    },
    edit_question: 'Fragen bearbeiten',
    edit_btraining_Detail: 'Bridgestone-Schulungsdetails bearbeiten',
    video_url: 'Video-URL',
    save_new_question: 'Neue Frage speichern',
    reward: 'Abbildung der Prämie - nicht erforderlich',
    poster: 'Posterbild',
    sliderImageValidation: 'Das Bild muss 1600x1040 px gross sein oder 2x/3x/4x dieser Grösse.',
    mainBoxImageValidation: 'Das Bild muss 368x150 px gross sein oder 2x/3x/4x dieser Grösse.',
    imageDimensions: 'Bildabmessungen',
    season: 'Saison',
    answers: 'Antworten',
    training_details: 'Trainingsdetails',
    extras: 'Weitere Informationen',
    duration: 'Dauer',
    price: 'Preis',
    min_participant: 'Mindestteilnehmerzahl',
    max_participant: 'Maximale Teilnehmerzahl',
    choose_trainingType: 'Trainingsart auswählen',
    update: 'Aktualisieren',
    cost_type: 'Kostentyp',
    save_detail: 'Einzelheiten speichern',
    slider_new: 'Neuer Main Teaser Slider',
    sliders: 'Main Teaser Slider',
    groups: 'Gruppen',
    slider: 'Main Teaser Slider bearbeiten',
    choose_showHideText: 'Text ein-/ausblenden',
    text_page_new: 'Neue Textseite',
    text_pages: 'Textseiten',
    text_page: 'Textseite',
    featured: {
      title: 'Teaser Produkte',
      bestseller: 'Meistgekauft',
      seasonal: 'Saisonales',
      affordable: 'Fast geschafft',
      autoBestsellers: 'Automatisch berechnete Bestseller anzeigen',
      affordableOffsetLabel: 'Maximaler Preisausgleich',
      affordableLimitLabel: 'Produktlimit anzeigen'
    },
    seasons: {
      all: 'Alle Jahreszeiten',
      summer: 'Sommer',
      winter: 'Winter',
      general: 'Allgemein'
    },
    addAddress: 'Adresse hinzufügen',
    administration: 'Verwaltung',
    password: 'Passwort',
    forcedPasswordChange: {
      title: 'Passwort ändern',
      description: 'Ihr temporäres Passwort muss geändert werden, bevor Sie auf die Anwendung zugreifen können.',
      enterNewPassword: 'Neues Passwort eingeben',
      repeatNewPassword: 'Neues Passwort wiederholen',
      strengthLabel: 'Passwortstärke',
      submit: 'Passwort ändern und anmelden',
      generatePassword: 'Sicheres Passwort generieren',
      success: 'Passwort wurde erfolgreich geändert',
      loginAfterChangeFailed:
        'Das Passwort wurde geändert, aber die automatische Anmeldung ist fehlgeschlagen. Bitte melden Sie sich mit Ihrem neuen Passwort an.',
      sameAsTemporaryPassword: 'Das neue Passwort darf nicht mit dem temporären Passwort übereinstimmen.',
      validationError: 'Bitte korrigieren Sie die Passwortanforderungen, bevor Sie fortfahren.',
      invalidToken: 'Ihre Passwortänderungssitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
      rules: {
        minLength: 'Mindestens 12 Zeichen',
        uppercase: 'Mindestens ein Großbuchstabe',
        lowercase: 'Mindestens ein Kleinbuchstabe',
        digit: 'Mindestens eine Ziffer',
        special: 'Sonderzeichen empfohlen'
      }
    },
    toastMessages: {
      success: 'Die Operation wurde erfolgreich abgeschlossen',
      error: 'Unerwarteter Fehler, bitte versuchen Sie es später erneut',
      invalid: 'Ungültige Werte im Formular',
      done: 'Erledigt!',
      requestProcessed: 'Die Anfrage wird bearbeitet. Einen Moment bitte...',
      noQuestions: 'Die Schulung muss mindestens 1 Frage enthalten',
      pointsAdded: 'Buchung erfolgt',
      selectUser: 'Wählen Sie einen Benutzer aus der Liste aus',
      selectOneField: 'Wählen Sie ein Feld aus',
      pointRemoveSoon: 'Punkte werden bald gelöscht',
      dataLoading: 'Die Daten werden geladen, bitte warten',
      shopStatsStartImportUser: 'Import wird gestartet: Shop-Statistik - BENUTZER',
      shopStatsPrepareMissingExportToken: 'Prepare-Schritt hat kein export_token zurückgegeben.',
      shopStatsPrepareInvalidNextChunk: 'Prepare-Schritt hat ein ungültiges next_chunk zurückgegeben.',
      shopStatsPrepareUnchangedChunkCursor: 'Prepare-Schritt hat unverändertes chunk/cursor zurückgegeben.',
      shopStatsPrepareMaxIterations: 'Prepare-Schritt hat die maximale Anzahl an Iterationen überschritten.',
      shopStatsConvertInvalidNextSubstep: 'Convert-Schritt hat ein ungültiges next_substep zurückgegeben.',
      shopStatsConvertMaxIterations: 'Convert-Schritt hat die maximale Anzahl an Iterationen überschritten.',
      shopStatsExportInvalidDownloadUrl: 'Export-Schritt hat keine gültige Download-URL zurückgegeben.',
      shopStatsDone: 'Fertig',
      shopStatsExportFailed: 'Export fehlgeschlagen'
    },
    stats: {
      users_list: 'Anzahl der Benutzer',
      external_trainings_request: 'Externe Schulungen',
      product_trainings_request: 'Online Trainings',
      bridgestone_courses_request: 'Bridgestone Schulungen',
      hunter_request: 'Werkstatteinrichtungen',
      investments_request: 'Investitionsunterstützung',
      orders_list: 'Bestellungen',
      history_list: 'Anmeldeverlauf',
      salespromotions_list: 'Verkaufsförderung',
      inactive_users: 'Neuanmeldungen freigeben',
      complaints_list: 'Beanstandungsformular',
      points_list: 'Punkteliste',
      kickback_list: 'Kickback fee',
      history_hour: 'Anmeldezeiten',
      tyre_list: 'Reifen'
    },
    product_trainings_request: 'Anfragen zu Online Trainings',
    bridgestone_courses_request: 'Anfragen zu Bridgestone-Schulungen',
    attempt_number: 'Versuchsnummer',
    thirdPartyInvoice: 'Rechnung Drittanbieter',
    userInvoice: 'Rechnung des Benutzers',
    bankAccountOwner: 'Kontoinhaber',
    open: 'Öffnen',
    appLogo: 'Anwendungslogo',
    appURL: 'Anwendungs-URL',
    appURLSSOLogin: 'URL nach SSO-Login',
    url: 'URL',
    url_text: 'URL-Text',
    choose_posterSide: 'Bildseite: ',
    left: 'Links',
    right: 'Rechts',
    disclaimer: 'Haftungsausschluss',
    supply: {
      history: 'Versorgungshistorie',
      quantity: 'Menge'
    },
    copyAsMain: 'Als Hauptteaser kopieren',
    news_feed_slider_list: 'Die Liste des Newsfeed-Sliders',
    usersPage: {
      boostersToApprove: 'Booster zur Genehmigung',
      lastLogin: 'Letzte anmeldung',
      isPreonboarded: 'Pre-Onboarding abgeschlossen',
      isBl: 'Bereichsleiter',
      customerNumbers: 'Kundennummer',
      branches: 'Geäst',
      balance: 'Kontostand',
      orders: 'Bestellungen',
      groups: 'Gruppen',
      notes: 'Anmerkungen',
      salesStaff: 'Aussendienst',
      parentBranch: 'Hauptgeschäft',
      childBranch: 'Filiale',
      addWholesaler: 'Grosshändler hinzufügen',
      addBranch: 'Filiale hinzufügen',
      tooltip: 'Um eine Filiale hinzuzufügen, müssen Sie die Kundennummer das Hauptgeschäft speichern',
      tooltipRmCnLocal: 'Lokale Kundennummer entfernen',
      tooltipRmCnDB: 'Kundennummer für Datenbank entfernen',
      statement: 'Kontoauszug',
      bank: {
        date: 'Datum',
        supplySourceReason: 'Bezugsquelle / Grund',
        customerNumber: 'Kdnr.',
        article: 'Artikel',
        brand: 'Marke',
        product: 'Produkt',
        type: 'Typ',
        dimension: 'Dimension',
        inch: 'Zoll',
        season: 'Saison',
        amount: 'Menge',
        otherActions: 'Sonstige Handlung bzw. Ursache',
        totalPoints: 'Punkte Gesamt',
        editPoint: 'Punkte bearbeiten',
        deleteManualPointConfirm: 'Möchten Sie den manuellen Punkteeintrag ({points} Punkte, {date}) wirklich löschen?',
        loadMore: 'Weitere 20 umsätze laden',
        showAll: 'Alle anzeigen',
        seasons: {
          all: 'All Season',
          summer: 'Summer',
          winter: 'Winter',
          general: 'General'
        }
      },
      advanced: 'Erweitert',
      deleteUser: 'Benutzer löschen',
      deleteUserConfirm: 'Möchten Sie den Benutzer wirklich löschen?',
      deleteUserSuccess: 'Der Benutzer wurde gelöscht.',
      deleteUserNotFound: 'Der Benutzer existiert nicht oder wurde bereits gelöscht.',
      deleteUserDealerConflict:
        'Der Händler kann nicht gelöscht werden, da er aktive Kundennummern hat. Entfernen Sie zuerst die zugehörigen Kundennummern.',
      deleteUserError: 'Der Benutzer konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
      generateTemporaryPassword: 'Temporäres Passwort generieren',
      generateTemporaryPasswordConfirm:
        'Sind Sie sicher, dass Sie das Passwort für {user} zurücksetzen möchten? Das aktuelle Passwort funktioniert danach nicht mehr.',
      temporaryPasswordGeneratedTitle: 'Temporäres Passwort generiert',
      temporaryPasswordOneTimeWarning:
        'Dieses Passwort wird nur einmal angezeigt. Kopieren Sie es, bevor Sie dieses Fenster schließen.',
      copyPassword: 'In Zwischenablage kopieren',
      passwordCopied: 'Kopiert',
      showPassword: 'Passwort anzeigen',
      hidePassword: 'Passwort ausblenden',
      generateTemporaryPasswordForbidden: 'Sie haben keine Berechtigung, ein temporäres Passwort zu generieren.',
      generateTemporaryPasswordNotFound: 'Benutzer existiert nicht.',
      passwordMismatch: 'Passwörter stimmen nicht überein',
      deleteCustomerNumber: 'Kundennummer löschen',
      manageSalesStaff: 'Aussendienst verwalten',
      availableSalesStaff: 'Verfügbarer Aussendienst',
      assignedSalesStaff: 'Zugewiesener Aussendienst',
      salesStaffTransferHint:
        'Wählen Sie links oder rechts einen oder mehrere Aussendienstmitarbeiter aus. Mit den Pfeilen verbinden oder trennen Sie sie mit diesem Händler.',
      transferSalesStaffRight: 'Ausgewählten Aussendienst verbinden',
      transferSalesStaffLeft: 'Ausgewählten Aussendienst trennen',
      salesStaffSearchNoResults: 'Kein passender Aussendienst gefunden.',
      addSalesStaff: 'Aussendienst hinzufügen',
      selectSalesStaffToAdd: 'Aussendienst zum Hinzufügen auswählen',
      noSalesStaffAssigned: 'Noch kein Aussendienst zugewiesen.',
      noSalesStaffAvailable: 'Alle verfügbaren Aussendienstmitarbeiter sind bereits zugewiesen.',
      addSalesStaffConfirm: 'Möchten Sie den Außendienst {salesStaff} wirklich diesem Händler hinzufügen?',
      deleteSalesStaffConfirm: 'Möchten Sie den Außendienst {salesStaff} wirklich von diesem Händler entfernen?',
      deleteAddressConfirm: 'Möchten Sie diese Adresse wirklich löschen?',
      milestones: {
        targetLabel: 'Ziel',
        yearLabel: 'Jahr',
        new: 'Neu',
        empty: 'Kein Ziel für ein Jahr. Erstellen Sie ein neues.',
        editTitle: 'Ziel bearbeiten',
        createTitle: 'Ziel erstellen',
        deleteConfirm: 'Möchten Sie den Meilenstein für Ziel {target} und Jahr {year} wirklich löschen?',
        targetRequiredInfo: 'Das Ziel ist für die korrekte Berechnung der Punkte für das ausgewählte Jahr erforderlich.'
      },
      milestonesTab: 'Meilensteine',
      campaignsTab: 'Kampagnen',
      dealerGroupsLabel: 'Händlergruppen',
      preOnboardStatusLabel: 'Pre-Onboard-Status',
      extraEmailsTab: 'Zusätzliche E-Mails',
      customerGroupsLabel: 'Kundengruppen',
      customerGroupsNone: 'Keine',
      showDealersList: 'Händlerliste anzeigen',
      staffDealersList: 'Ihre Händlerliste',
      syncSelectedDealers: 'Ausgewählte Händler synchronisieren',
      connectAllDealersFromBs: 'Alle Händler aus BS+ verbinden',
      connectAllDealersConfirmTitle: 'Alle Händler verbinden',
      connectAllDealersConfirmDescription: 'Möchten Sie wirklich alle Händler mit diesem Staff-Benutzer verbinden?',
      disconnectAllDealersConfirmTitle: 'Alle Händler trennen',
      disconnectAllDealersConfirmDescription: 'Möchten Sie wirklich alle Händler von diesem Staff-Benutzer trennen?',
      transferDealersToAnotherBsStaff: 'Händler an einen anderen BS-Mitarbeiter übertragen',
      showingCount: 'Angezeigt {visible} / {total}',
      groupDealersSelectedCount: '{selected} ausgewählt',
      groupDealersUnselectedCount: '{unselected} nicht ausgewählt',
      showGroupOnly: 'Nur anzeigen',
      clearGroupFilter: 'Alle Gruppen anzeigen',
      noDealersInSelectedGroups: 'Keine Händler in den ausgewählten Gruppen',
      downloadConnectedDealers: 'Verbundene Händler herunterladen',
      showGroupFilters: 'Gruppenfilter anzeigen',
      hideGroupFilters: 'Gruppenfilter ausblenden',
      staffDealersToolbarSync: 'Synchronisation',
      staffDealersToolbarBulk: 'Massenaktionen',
      staffDealersToolbarExport: 'Export',
      importDealersByEmail: 'Händler aus Excel importieren',
      importDealersByEmailTitle: 'Händler per E-Mail importieren',
      importDealersByEmailInfo: 'Laden Sie eine Excel-Datei (.xlsx, .xls) mit E-Mail-Adressen nur in Spalte A hoch.',
      importDealersByEmailHeaderInfo: 'Die erste Zeile kann die Kopfzeile "email" enthalten.',
      importDealersByEmailEmptySheet: 'Die Excel-Datei enthält keine Daten.',
      importDealersByEmailEmptyColumn: 'Spalte A enthält keine E-Mail-Adressen.',
      importDealersByEmailMultipleColumns: 'Die Datei darf nur eine Spalte mit E-Mail-Adressen enthalten.',
      importDealersByEmailReadError: 'Die Excel-Datei konnte nicht gelesen werden.',
      importDealersByEmailValidating: 'Datei wird validiert...',
      importDealersByEmailSummaryTitle: 'Import-Zusammenfassung',
      importDealersByEmailAlreadyConnected: 'Bereits verbunden',
      importDealersByEmailNewConnections: 'Neue Verbindungen',
      importDealersByEmailNotFound: 'Nicht in BS+ gefunden',
      importDealersByEmailInvalidEmails: 'Ungültiges E-Mail-Format',
      importDealersByEmailDuplicates: 'Doppelte E-Mails in der Datei',
      importDealersByEmailSyncButton: 'Verbinden und synchronisieren',
      importDealersByEmailNoNewConnections: 'Alle E-Mails aus der Datei sind bereits verbunden.',
      importDealersByEmailShowingCount: 'Angezeigt {shown} von {total}',
      notesHelpText: 'Muss 8-20 Wörter lang sein.',
      indirectAccessAlert: 'Dieser Benutzer hat eingeschränkten Zugriff wegen INDIRECT-Kundentyp-Pfad.',
      parentAttributesNotEnabled:
        'Parent Attributes können in diesem Markt nicht gespeichert werden. Bitten Sie einen Super-Admin, diese Funktion freizuschalten.',
      termsConfirmed: 'AGB bestätigt',
      privacyConfirmed: 'Datenschutzerklärung bestätigt',
      approvedByBs: 'Von BS+ genehmigt',
      extraDocsConfirmed: 'Zusätzliche Dokumente für indirekten Kunden bestätigt',
      restrictedAccess: 'Eingeschränkter Zugriff',
      revokeApproval: 'Genehmigung widerrufen',
      approve: 'Genehmigen',
      allowPointsCalculationConfirm:
        'Do you want to activate/deactivate points calculation for customer number {customerNumber} ({wholesaler})?',
      calculateOneCustomerNumberTitle: 'Calculate points for customer number',
      calculateOneCustomerNumberQuestion: 'Would you like to calculate data for customer number {customerNumber}?',
      calculateOneCustomerNumberWholesaler: 'Wholesaler: {wholesaler}',
      calculateOneCustomerNumberYearLabel: 'Year',
      activateCustomerNumberConfirm: 'Are you sure you want to activate customer number {customerNumber} ({wholesaler})?',
      deactivateCustomerNumberConfirm: 'Are you sure you want to deactivate customer number {customerNumber} ({wholesaler})?',
      saveCustomerNumberConfirm:
        'Möchten Sie die Kundennummer {customerNumber} ({wholesaler}) wirklich speichern oder aktualisieren?',
      selectRole: 'Rolle auswählen',
      selectClientType: 'Kundentyp auswählen',
      selectWholesaler: 'Grosshändler auswählen',
      pointsSummary: {
        year: 'Jahr',
        actions: 'Aktionen',
        revert: 'Verfall zurücksetzen',
        recalculate: 'Verfall neu berechnen',
        currentPoints: 'Punktestand',
        pointsFromCurrentYear: 'Punkte aus dem aktuellen Jahr ({year})',
        atRiskLabel: 'Auszugebende Punkte bis 31.03.{year}',
        loadError: 'Punkteübersicht konnte nicht geladen werden.',
        invalidYear: 'Das Jahr muss eine Ganzzahl zwischen 2000 und 3000 sein.',
        recalculateConfirm: 'Der alte Verfallseintrag wird entfernt und für das Jahr {year} neu berechnet. Fortfahren?',
        revertSuccess: 'Entfernte Einträge: {count}',
        revertConfirm: 'Der Verfallseintrag für das Jahr {year} wird entfernt. Fortfahren?',
        recalculateSuccess: 'Neu berechnet. Verfallene Punkte: {points}',
        recalculateNoop: 'Für dieses Jahr gibt es keine zu verfallenden Punkte.'
      }
    },
    recoverUser: 'Benutzer zurückholen',
    pieces_per_set: 'Verpackungseinheiten',
    new: 'Neu',
    all: 'Alle',
    showAddress: 'Adresse zeigen',
    showGroup: 'GKA & Bl-Alt zeigen',
    showPoints: 'Punktestände anzeigen',
    showKickbacks: 'Show kickback fee',
    external_sales: 'Aussendienst',
    login_from: 'Letzter Login (von)',
    login_to: 'Letzter Login (bis)',
    searchUserDownload: {
      title: 'Suchdaten herunterladen',
      description: 'Wählen Sie das Dateiformat für den Export.',
      formatCsv: 'CSV (.csv)'
    },
    check: 'Prüfen',
    reject: 'Ablehnen',
    reason: 'Grund',
    active_by: 'Aktiviert von',
    sharePassword: 'Teilen Sie dieses Passwort mit dem neuen Administrator',
    activeBtn: 'Jetzt aktivieren',
    newUserVerify: 'Überprüfung der neuen Registrierung',
    complaintForm: {
      sections: {
        general: {
          title: 'allgemein',
          ordinance: 'Ordnungsbegriff des Händlers',
          generalEmail: 'Ihre E-Mailadresse',
          country: 'Land',
          pickupLocation: 'Abholort'
        },
        regulator: {
          title: 'anschrift reifenhändler - regulierer'
        },
        vehicleDetails: {
          title: 'Angaben zum Fahrzeug',
          vehicleManufacturer: 'Fahrzeughersteller',
          vehicleModelType: 'Fahrzeugmodell und Typbezeichnung lt. Zulassung',
          firstRegistration: 'Erstzulassung',
          enginePower: 'Motorleistung (KW z.B. 150)',
          originalEquipment: 'Erstausrüstung',
          tireMilageHours: 'Laufleistung Reifen (km) / Betriebsstunden',
          milageOrHours: 'Km oder Stunden (z.B. 2000)'
        },
        tyre: {
          tireSizeExample: 'Reifengrösse (z.B. 215/60/16)',
          speedLoadIndex: 'Geschwindigkeits- / Lastindex',
          profileDesignation: 'Profilbezeichnung inc. Spezifikation',
          dot: 'DOT',
          truckSerialNo: 'Serien-Nr. (nur bei LKW Reifen)',
          complaintReason: 'Beanstandungsgrund',
          isTyreReplaced: 'Wurden die Reifen bereits ersetzt?',
          ifYesTyre: 'Falls ja, Marke der Ersatzreifen',
          clerkName: 'Name des Sachbearbeiters',
          complaintReasonText: 'Beanstandungsgrund Text'
        }
      }
    },
    yesText: 'Ja',
    noText: 'Nein',
    tyre: 'Reifen',
    maintenance_mode_title: 'Wartungsmodus',
    maintenance_mode_description:
      'Möchten Sie wirklich fortfahren? Wenn diese Option aktiviert ist, ist die Website für Benutzer vorübergehend nicht verfügbar.',
    maintenance_mode_disable_title: 'Wartungsmodus deaktivieren',
    maintenance_mode_disable_description: 'Möchten Sie wirklich fortfahren? Die Website wird für Benutzer wieder verfügbar.',
    buttons: {
      close: 'Schliessen',
      send: 'Senden',
      validateFile: 'Datei prüfen',
      back: 'Zurück',
      placeOrder: 'Verbindlich Bestellen',
      download: 'Herunterladen',
      downloadData: 'Daten herunterladen',
      downloadSearchResults: 'Suchdaten herunterladen',
      openDownloadModal: 'Download-Daten-Modal anzeigen',
      loading: 'Laden',
      approve: 'Genehmigen',
      deleteOrder: 'Auftrag löschen',
      archive: 'Archiv',
      acceptAll: 'Alle akzeptieren',
      advanceSearch: 'Erweiterte Suche',
      addMenu: 'Menü hinzufügen',
      setMaintenance: 'Wartung einstellen',
      hideMaintenance: 'Wartung ausblenden',
      deactivate: 'Deaktivieren',
      importSelected: 'Ausgewählte importieren',
      importArticleNumbers: 'Diese Artikel importieren',
      startOver: 'Neu starten',
      loadMore: 'Mehr laden',
      loadAll: 'Alle laden',
      clearFilters: 'Filter zurücksetzen',
      toSearch: 'Suchen',
      delete: 'Löschen',
      allowAccessToUsers: 'Zugriff auf Gruppe von Benutzern erlauben'
    },
    others: 'Andere',
    archive_training_title: 'Schulung archivieren',
    archive_training: 'Möchten Sie diese Schulung wirklich archivieren?',
    delete_menu: 'Möchten Sie den Menüpunkt löschen?',
    no_entries: 'Keine Einträge',
    external_url: 'Externe URL',
    incomplete_address: 'Adresse ist unvollständig. überprüfen Sie bitte',
    request_from: 'Anfrage vom',
    let_see_points: 'Lassen Sie den Benutzer Marketingpunkte sehen',
    let_see_kickback: 'Lassen Sie den Benutzer die Kickback-Gebühr sehen',
    major: 'Grep',
    media_category: 'Kategorie „Medien“',
    dragHere: 'Legen Sie die Dateien hier ab ...',
    dragDropSelectFiles: 'Dateien hierhin ziehen und ablegen oder klicken, um Dateien auszuwählen',
    publicFileUploadWarning:
      'Hochgeladene Dateien sind öffentlich zugänglich. Wenn versehentlich öffentliche oder sensible Daten freigegeben werden, kann das für den Benutzer zu ernsten Problemen führen. Das Hochladen erfolgt auf eigene Verantwortung.',
    uploadingFiles: 'Dateien werden hochgeladen',
    uploadingCurrentFile: 'Aktuelle Datei',
    allCategories: 'Alle Kategorien',
    addEmbbeded: 'Fügen Sie eingebetteten Code hinzu',
    canReceivePoints: 'Kann Punkte erhalten',
    canUsePoints: 'Kann Punkte gebrauchen',
    wholesaler_management: {
      modal: {
        description: 'Welche Daten kann der Grosshändler in den Händlerdetails einsehen?'
      }
    },
    personalData: 'Persönliche daten',
    operatingData: 'Betriebsdaten',
    orderDelivery: 'Lieferadresse',
    diffDeliveryAddres: 'Lieferadresse hinzufügen',
    current_tyres_amount: 'Reifenmenge',
    current_points: 'Punktestand',
    current_kickbacks: 'Kick-back',
    change_role_info:
      'Beim Ändern einer Rolle im <b>Bridgestone PLUS-System</b> werden Verbindungen gelöscht, die mit einer bestimmten Rolle verknüpft sind, z. B. Punkte, Kundennummern, Verbindungen zwischen einem Bridgestone-Agenten und einem Händler, Bestellungen usw. Sind Sie sicher, dass Sie diese Änderung vornehmen möchten? Weil es keinen Weg zurück gibt?',
    firstRegistration: 'Erstanmeldung',
    mediaCategories: {
      products: 'Produkte',
      brand_and_solutions: 'Marke & Lösungen',
      season_and_promotions: 'Saison & Aktionen',
      format: 'Format',
      cars_and_vans: 'Pkw & Transporter',
      truck_and_buses: 'Lkw & Bus',
      motorcycle: 'Motorrad',
      agriculture: 'Landwirtschaft',
      construction_machinery: 'Baumaschinen',
      bridgestone: 'Bridgestone',
      firestone: 'Firestone',
      bandag: 'Bandag',
      bleetcare: 'Fleet Care',
      webfleet: 'Webfleet',
      summer: 'Sommer',
      winter: 'Winter',
      all_season: 'All Season',
      promotions: 'Promotions',
      video_in_store: 'Video mit Untertitel ',
      video_online: 'Video ohne Untertitel',
      banner_website: 'Banner',
      banner_social_media: 'Social Media',
      logos: 'Logos',
      b_drive: 'B-drive',
      media_library: 'Media library',
      media_packages: 'Media packages',
      material: 'Materialien',
      price_list: 'Preislisten',
      brochures: 'Produktbrochuren',
      price: 'Pricat'
    },
    fileType: {
      label: 'File type',
      video: 'Video',
      image: 'Image',
      embeded: 'Embeded',
      pdf: 'PDF'
    },
    deleteMediaModal: {
      title: 'Mediensammlung löschen',
      description: 'Bestätigen Sie das Löschen der Dateisammlung? Alle verbundenen Dateien werden gelöscht.',
      filesLabel: 'Dateien, die gelöscht werden',
      noFiles: 'Keine Dateien in dieser Sammlung'
    },
    deleteMediaFileModal: {
      title: 'Datei aus Sammlung löschen',
      description: 'Möchten Sie die Datei aus dieser Sammlung löschen?'
    },
    deleteBrochureFileModal: {
      title: 'Datei aus Sammlung löschen',
      description: 'Möchten Sie die Datei "{fileName}" aus dieser Sammlung löschen?',
      fileNameFallback: 'Unbekannte Datei'
    },
    deleteBrochureModal: {
      title: 'Broschüre löschen',
      description: 'Möchten Sie die Broschüre "{name}" wirklich löschen?',
      nameFallback: 'Unbekannte Broschüre',
      filesLabel: 'Dateien, die gelöscht werden',
      noFiles: 'Keine Dateien in dieser Broschüre'
    },
    languages: {
      aa: 'Afar',
      ab: 'Abchasisch',
      ae: 'Avestisch',
      af: 'Afrikaans',
      ak: 'Akan',
      am: 'Amharisch',
      an: 'Aragonesisch',
      ar: 'Arabisch',
      as: 'Assamesisch',
      av: 'Awarisch',
      ay: 'Aymara',
      az: 'Aserbaidschanisch',
      ba: 'Baschkirisch',
      be: 'Belarussisch',
      bg: 'Bulgarisch',
      bh: 'Bhodschpuri',
      bi: 'Bislama',
      bm: 'Bambara',
      bn: 'Bengalisch',
      bo: 'Tibetisch',
      br: 'Bretonisch',
      bs: 'Bosnisch',
      ca: 'Katalanisch',
      ce: 'Tschetschenisch',
      ch: 'Chamorro',
      co: 'Korsisch',
      cr: 'Cree',
      cs: 'Tschechisch',
      cu: 'Kirchenslawisch',
      cv: 'Tschuwaschisch',
      cy: 'Walisisch',
      da: 'Dänisch',
      de: 'Deutsch',
      dv: 'Dhivehi',
      dz: 'Dzongkha',
      ee: 'Ewe',
      el: 'Griechisch',
      en: 'Englisch',
      eo: 'Esperanto',
      es: 'Spanisch',
      et: 'Estnisch',
      eu: 'Baskisch',
      fa: 'Persisch',
      ff: 'Ful',
      fi: 'Finnisch',
      fj: 'Fidschi',
      fo: 'Färöisch',
      fr: 'Französisch',
      fy: 'Westfriesisch',
      ga: 'Irisch',
      gd: 'Gälisch (Schottland)',
      gl: 'Galicisch',
      gn: 'Guaraní',
      gu: 'Gujarati',
      gv: 'Manx',
      ha: 'Haussa',
      he: 'Hebräisch',
      hi: 'Hindi',
      ho: 'Hiri-Motu',
      hr: 'Kroatisch',
      ht: 'Haiti-Kreolisch',
      hu: 'Ungarisch',
      hy: 'Armenisch',
      hz: 'Herero',
      ia: 'Interlingua',
      id: 'Indonesisch',
      ie: 'Interlingue',
      ig: 'Igbo',
      ii: 'Yi',
      ik: 'Inupiak',
      io: 'Ido',
      is: 'Isländisch',
      it: 'Italienisch',
      iu: 'Inuktitut',
      ja: 'Japanisch',
      jv: 'Javanisch',
      ka: 'Georgisch',
      kg: 'Kongolesisch',
      ki: 'Kikuyu',
      kj: 'Kwanyama',
      kk: 'Kasachisch',
      kl: 'Grönländisch',
      km: 'Khmer',
      kn: 'Kannada',
      ko: 'Koreanisch',
      kr: 'Kanuri',
      ks: 'Kaschmiri',
      ku: 'Kurdisch',
      kv: 'Komi',
      kw: 'Kornisch',
      ky: 'Kirgisisch',
      la: 'Latein',
      lb: 'Luxemburgisch',
      lg: 'Ganda',
      li: 'Limburgisch',
      ln: 'Lingala',
      lo: 'Laotisch',
      lt: 'Litauisch',
      lu: 'Luba-Katanga',
      lv: 'Lettisch',
      mg: 'Malagasy',
      mh: 'Marschallesisch',
      mi: 'Māori',
      mk: 'Mazedonisch',
      ml: 'Malayalam',
      mn: 'Mongolisch',
      mr: 'Marathi',
      ms: 'Malaiisch',
      mt: 'Maltesisch',
      my: 'Birmanisch',
      na: 'Nauruisch',
      nb: 'Norwegisch (Bokmål)',
      nd: 'Nord-Ndebele',
      ne: 'Nepalesisch',
      ng: 'Ndonga',
      nl: 'Niederländisch',
      nn: 'Norwegisch (Nynorsk)',
      no: 'Norwegisch',
      nr: 'Süd-Ndebele',
      nv: 'Navajo',
      ny: 'Nyanja',
      oc: 'Okzitanisch',
      oj: 'Ojibwa',
      om: 'Oromo',
      or: 'Oriya',
      os: 'Ossetisch',
      pa: 'Punjabi',
      pi: 'Pali',
      pl: 'Polnisch',
      ps: 'Paschtu',
      pt: 'Portugiesisch',
      qu: 'Quechua',
      rm: 'Rätoromanisch',
      rn: 'Rundi',
      ro: 'Rumänisch',
      ru: 'Russisch',
      rw: 'Kinyarwanda',
      sa: 'Sanskrit',
      sc: 'Sardisch',
      sd: 'Sindhi',
      se: 'Nordsamisch',
      sg: 'Sango',
      si: 'Singhalesisch',
      sk: 'Slowakisch',
      sl: 'Slowenisch',
      sm: 'Samoanisch',
      sn: 'Shona',
      so: 'Somali',
      sq: 'Albanisch',
      sr: 'Serbisch',
      ss: 'Swazi',
      st: 'Süd-Sotho',
      su: 'Sundanesisch',
      sv: 'Schwedisch',
      sw: 'Suaheli',
      ta: 'Tamil',
      te: 'Telugu',
      tg: 'Tadschikisch',
      th: 'Thailändisch',
      ti: 'Tigrinya',
      tk: 'Turkmenisch',
      tl: 'Filipino',
      tn: 'Tswana',
      to: 'Tongaisch',
      tr: 'Türkisch',
      ts: 'Tsonga',
      tt: 'Tatarisch',
      tw: 'Akan',
      ty: 'Tahitisch',
      ug: 'Uigurisch',
      uk: 'Ukrainisch',
      ur: 'Urdu',
      uz: 'Usbekisch',
      ve: 'Venda',
      vi: 'Vietnamesisch',
      vo: 'Volapük',
      wa: 'Wallonisch',
      wo: 'Wolof',
      xh: 'Xhosa',
      yi: 'Jiddisch',
      yo: 'Yoruba',
      za: 'Zhuang',
      zh: 'Chinesisch',
      zu: 'Zulu',
      at: 'Deutsch',
      cz: 'Tschechisch',
      'fr-FR': 'Französisch',
      'fr-BE': 'Französisch',
      'nl-BE': 'Niederländisch'
    },
    colleague: 'Kollege',
    tradeInDate: 'Inzahlungnahmedatum',
    vouchers: {
      id: 'ID',
      code: 'Code',
      colleagueName: 'Name Kollege',
      dealerName: 'Name Händler',
      download: 'Download',
      points: 'Anzahl der Punkte pro Gutschein',
      amount: 'Anzahl Vouchers',
      deleteConfirmTitle: 'Gutschein löschen',
      deleteConfirmDescription: 'Möchten Sie diesen Gutschein wirklich löschen?'
    },
    selectText: 'Wählen',
    brochureCategories: {
      products: 'Produkte',
      brand_and_solutions: 'Marke & Lösungen',
      season_and_promotions: 'Saison & Aktionen',
      format: 'Format',
      cars_and_vans: 'Pkw & Transporter',
      truck_and_buses: 'Lkw & Bus',
      motorcycle: 'Motorrad',
      agriculture: 'Landwirtschaft',
      construction_machinery: 'Baumaschinen',
      bridgestone: 'Bridgestone',
      firestone: 'Firestone',
      bandag: 'Bandag',
      bleetcare: 'Fleetcare',
      webfleet: 'Webfleet',
      material: 'Materialien',
      brochures: 'Produktbrochuren',
      price_list: 'Preislisten',
      materials: 'Materialien',
      summer: 'Sommer',
      winter: 'Winter',
      all_season: 'Ganzjahresreifen',
      trucks: 'Lkw',
      technology: 'Technologie',
      oe: 'OE',
      allSeason: 'Ganzjahresreifen',
      season: 'Saison',
      promotions: 'Aktionen'
    },
    deleteMainBox: {
      title: 'Hauptfeld löschen',
      description: 'Möchten Sie diesen Artikel wirklich löschen?'
    },
    apps: {
      app_new: 'Neue App',
      title: 'Anwendungen',
      name: 'Name',
      code: 'Code',
      ownerName: 'Name des Eigentümers',
      ownerEmail: 'E-Mail des Eigentümers',
      firstName: 'Vorname',
      lastName: 'Nachname',
      chooseFile: 'Datei auswählen',
      noFileSelected: 'Keine Datei ausgewählt',
      tabDetails: 'Details',
      tabBusinessUnits: 'Geschäftseinheiten',
      tabLocalizedContent: 'Lokalisierte Inhalte',
      tabOwners: 'App-Eigentümer',
      isVisibleEveryone: 'Offener Zugang',
      isSSOReady: 'SSO',
      relationDirect: 'Direkt',
      relationInDirect: 'Indirekt',
      clientType: 'Kundentyp',
      clientTypeEveryone: 'Alle',
      clientTypeDirect: 'Direkt',
      clientTypeIndirect: 'Indirekt',
      clientTypeDirectIndirect: 'Direkt + Indirekt',
      isVisibleEveryoneLabel:
        'Wenn aktiviert, ist der Zugang für alle Benutzer offen, die den Sichtbarkeitseinstellungen unten entsprechen. Wenn deaktiviert, ist der Zugang eingeschränkt und muss pro Benutzer im Benutzerprofil oder per Benutzerlisten-Upload manuell vergeben werden.',
      isSSOReadyLabel: 'Ist SSO-fähig?',
      relationDirectLabel: 'Direkte Kunden',
      relationInDirectLabel: 'Indirekte Kunden',
      removeOwner: 'Entfernen',
      addNextOwner: 'Nächsten Eigentümer hinzufügen',
      saveOwners: 'Eigentümer speichern',
      local_app: 'Lokale App',
      managed_globally_info: 'Diese Anwendung wird vom Global Admin verwaltet'
    },
    bsPlus: {
      onboarding: {
        title: "Willkommen Bridgestone <span class='text-danger'>PLUS</span>",
        termsAndConditions: 'Allgemeine Geschäftsbedingungen',
        accept: 'Akzeptieren',
        decline: 'Ablehnen',
        dataModal:
          'Um dieses Angebot auf Ihre Interessen zuzuschneiden, bitten wir Sie, kurz Ihre Produktinteressen oder Geschäftsbereiche anzugeben.',
        scrollToAccept: 'Scrollen Sie nach unten, um unsere Bedingungen zu akzeptieren und fortzufahren',
        welcomeMessage: 'Willkommen bei Bridgestone Plus',
        tailorOffer:
          'Um dieses Angebot auf Ihre Interessen zuzuschneiden, bitten wir Sie, kurz Ihre Produktinteressen oder Geschäftsbereiche anzugeben.',
        bussinessType:
          'Um dieses Angebot auf Ihre Interessen zuzuschneiden, bitten wir Sie, kurz Ihre Produktinteressen oder Geschäftsbereiche anzugeben.',
        selectAreas: 'Bitte wählen Sie aus den folgenden Bereichen',
        multipleAnswers: '(Mehrfachantworten möglich):',
        personalPreferences: 'Persönliche Präferenzen',
        carTyres: 'Reifen für Autos, SUVs und Nutzfahrzeuge',
        motorcyclesTyres: 'Reifen für Motorräder',
        truckBusTyres: 'Reifen für Lkw und Busse',
        agricultureTyres: 'Reifen für landwirtschaftliche Fahrzeuge',
        otrTyres: 'OTR-Reifen',
        save: 'Speichern',
        businessRelationship: 'Welche Geschäftsbeziehung haben Sie zu Bridgestone?',
        selectRelationship: 'Bitte wählen Sie*:',
        tradingPartner: 'Ich bin ein Handelspartner, der...',
        tradingPartnerDirect: '... direkt bei Bridgestone bestellt',
        tradingPartnerIndirect: '... indirekt bestellt (z. B. über den Großhandel)',
        tradingPartnerBoth: '... sowohl direkt als auch indirekt bestellt',
        fleetResponsibleDirect: 'Ich bin ein Flottenverantwortlicher, der...',
        fleetResponsibleIndirect: '... indirekt bestellt (über Handel oder Großhandel)',
        fleetResponsibleBoth: '... direkt und indirekt bestellt',
        noBusinessRelationship: '<b>Ich habe keine Geschäftsbeziehung mit Bridgestone</b> (weder direkt noch indirekt)',
        yourCustomerNumber: 'Ihre Bridgestone-Kundennummer*:',
        enterCustomerNumber: 'Geben Sie Ihre Kundennummer ein',
        waitPersonalisedView: 'Bitte warten Sie einen Moment, Ihre personalisierte Ansicht von BRIDGESTONE PLUS wird erstellt.',
        personalised: 'PERSONALISIEREN',
        plusInfo: 'Hier finden Sie Informationen zu Ihrem Plus-Konto und Ihrem Plus-Posteingang.',
        continue: 'Fortfahren',
        skip: 'Überspringen',
        oneOfTwo: '1 von 2',
        openApps:
          'Sie können die Apps, für die Sie bereits registriert sind, direkt öffnen. Sie können auch Zugang zu anderen Apps anfordern, die für Sie relevant sein könnten.',
        requiredFields: 'Bitte füllen Sie die Pflichtfelder aus: Titel, Vorname, Nachname, Vorname',
        stage: 'Schritt',
        chooseOne: '(Bitte mindestens ein Kästchen ankreuzen)',
        required: '*Pflichtfelder',
        lengthCsNumber: 'Länge der Kundennummer: 6–10 Ziffern',
        waitForAdminApproval:
          'Vielen Dank, dass Sie sich für das Bridgestone Plus Rewards-Programm angemeldet haben. Wir prüfen derzeit Ihre Bewerbung. Sie erhalten eine Bestätigungs-E-Mail, sobald Ihr Antrag genehmigt wurde.',
        selectTyres: 'TÄTIGKEITSBEREICH UND PROFIL'
      }
    },
    anyLogin: 'beliebige Anmeldung',
    frontend_menu: {
      account: 'Profil',
      plus: 'Über Bridgestone Plus',
      salesSupport: 'Vertriebsunterstützung',
      mailbox: 'Postfach',
      about: 'Über Bridgestone Plus',
      trainingAndCourses: 'Online-Trainings',
      externalTraining: 'Externe Schulungen',
      productInfo: 'Produktinformationen',
      productBrochures: 'Broschüren',
      priceLists: 'Preisliste',
      price: 'Preis',
      complaintForm: 'Reklamationsformular',
      sales_support: 'Vertriebsunterstützung',
      contact_service: 'Kontakt & Service',
      logOut: 'Abmelden',
      news: 'Newsfeeds',
      news_feeds: 'Newsfeeds',
      service_number: 'Kontakt & Service',
      brochure_prices: 'Broschüren und Preisliste',
      trainings: 'Schulungen',
      salesPromotions: 'Verkaufsaktionen',
      stammdaten: 'Mein Profil',
      onlineTrainings: 'Online-Trainings',
      shop: 'Shop',
      preislisten: 'Preisliste',
      medias: 'Medien',
      media: 'Medien',
      manageLinks: 'Menülinks verwalten',
      noModuleLinksAvailable: 'Für diesen Tenant sind keine Modul-Links verfügbar.'
    },
    customerNumbersAssistant: {
      date: {
        title: 'Punkte ab Datum X berechnen'
      },
      import: {
        openButton: 'Kundennummern importieren',
        loadingModal: 'Modal wird geladen...',
        title: 'Kundennummern aus Excel importieren',
        validateButton: 'Datei prüfen',
        submitButton: 'An API senden',
        submitButtonLoading: 'Wird gesendet...',
        selectWholesalerLabel: 'Großhändler',
        selectGroupLabel: 'Gruppe',
        selectWholesalerPlaceholder: 'Großhändler auswählen',
        selectGroupPlaceholder: 'Gruppe auswählen (optional)',
        requirementsTitle: 'Dateianforderungen',
        fileFormatRequirement: 'Nur Excel-Datei: .xlsx oder .xls',
        headerRequirement: 'Kopfzeile muss sein: Customer number, Email (Spalten A/B).',
        createdLabel: 'Erstellt',
        alreadyExistsLabel: 'Bereits vorhanden',
        success: 'Excel-Datei ist gültig.',
        previewTitle: 'Vorschau',
        previewCount: '{count} Zeilen, {pageSize} Zeilen pro Seite.',
        columnOne: 'Spalte 1',
        columnTwo: 'Spalte 2',
        previousPage: 'Zurück',
        nextPage: 'Weiter',
        pageInfo: 'Seite {current} / {total}',
        progressLabel: 'Fortschritt',
        errors: {
          wholesalerRequired: 'Großhändler ist erforderlich.',
          groupRequired: 'Gruppe ist erforderlich.',
          fileRequired: 'Excel-Datei ist erforderlich.',
          emptyWorkbook: 'Excel-Arbeitsmappe ist leer.',
          invalidHeaders: 'Datei muss genau 2 Spalten enthalten: Kundennummer und E-Mail.',
          emptyRows: 'Datei enthält keine Datenzeilen.',
          firstTwoColumnsRequired: 'Zeile {row}: Die erste und zweite Spalte müssen ausgefüllt sein.',
          invalidCustomerNumber: 'Ungültige Kundennummer in Zeile {row}. Nur Buchstaben und Ziffern sind erlaubt.',
          invalidEmail: 'Ungültige E-Mail in Zeile {row}.',
          invalidFileType: 'Nur Excel-Dateien (.xlsx, .xls) sind erlaubt.',
          readError: 'Excel-Datei konnte nicht gelesen werden.',
          submitFailed: 'Datensätze konnten nicht an die API gesendet werden.'
        }
      }
    },
    product_sync: {
      syncEnabled: 'Synchronisation aktiviert',
      syncDisabled: 'Synchronisation deaktiviert',
      syncDisable: 'Über API aktualisieren',
      syncEnable: 'Manuelles Produktupdate',
      notAvailableDisable: 'Im Shop nicht sichtbar',
      notAvailableEnable: 'Im Shop sichtbar',
      notAvailableDisabled: 'Im Shop nicht sichtbar',
      notAvailableEnabled: 'Im Shop sichtbar',
      notAvailableError: 'Fehler: Nicht verfügbar',
      syncError: 'Synchronisationsfehler',
      tooltip: {
        syncEnable:
          'Bitte beachten Sie, dass die manuelle Produktaktualisierung nur die Preis-/Punkteverwaltung betrifft. Alle anderen produktbezogenen Informationen werden über die API aktualisiert und können vom lokalen Administrator nicht geändert werden.',
        notAvailableEnable: 'Produkt für diesen Markt als nicht verfügbar markieren.',
        notAvailableDisable: 'Produkt für diesen Markt wieder verfügbar machen.'
      }
    },
    category_sync: {
      syncEnabled: 'Bildsynchronisation aktiviert',
      syncDisabled: 'Bildsynchronisation deaktiviert',
      syncDisable: 'Bild über API aktualisieren',
      syncEnable: 'Manuelles Bildupdate',
      syncError: 'Bildsynchronisationsfehler',
      tooltip: {
        syncEnable:
          'Das Deaktivieren der Synchronisation betrifft nur das Kategoriebild. Name, Beschreibung und Status stammen weiterhin aus dem globalen Katalog. Solange die Bildsynchronisation aktiviert ist, wird das Bild aus dem globalen Katalog übernommen und kann lokal nicht geändert werden.'
      }
    },
    priceCategories: {
      pkw: 'Pkw, 4x4 und Transporter',
      motorcycles: 'Motorräder',
      trucksAndBuses: 'Lkw und Busse',
      agriculture: 'Landwirtschaft',
      constructionMachineryOtr: 'Baumaschinen OTR'
    },
    campaigns: {
      title: 'Kampagnen',
      new: 'Neue Kampagne',
      edit: 'Kampagne bearbeiten',
      name: 'Kampagnenname',
      subtitle: 'Kampagnenuntertitel (optional)',
      description: 'Beschreibung',
      type: 'Kampagnentyp',
      selectType: 'Kampagnentyp auswählen',
      periodName: 'Periodenname',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      newPeriod: 'Neue Periode',
      image: 'Bild',
      url: 'URL',
      active: 'Aktiv',
      types: {
        'performance-speedy': 'Performance',
        'performance-cd': 'Performance CD',
        'booster-ccs': 'Booster CCS'
      },
      transferDealersModal: {
        openButton: 'Händler in eine andere Kampagne verschieben',
        title: 'Kampagne auswählen',
        description: 'Sie können Händler aus der aktuellen Kampagne {campaignName} in eine andere verschieben.',
        loadingCampaigns: 'Kampagnen werden geladen...',
        selectCampaignPlaceholder: 'Kampagne auswählen',
        submit: 'Anfrage senden',
        sending: 'Wird gesendet...',
        requestSent: 'Anfrage gesendet',
        requestFailed: 'Anfrage konnte nicht gesendet werden'
      },
      alert: {
        title: 'Bestätigen',
        desc: 'Möchten Sie diese Kampagne wirklich entfernen?'
      }
    }
  },
  wholesaler_management: {
    modal: {
      description: 'Welche Daten kann der Grosshändler in den Händlerdetails einsehen?'
    }
  },
  marketingConsents: {
    pageTitle: 'Marketing-Zustimmungen',
    title: 'Titel',
    status: 'Status',
    noConsents: 'Keine Marketing-Zustimmungen verfügbar',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    enable: 'Aktivieren',
    disable: 'Deaktivieren',
    enableTitle: 'Marketing-Zustimmung aktivieren',
    enableMessage: 'Sind Sie sicher, dass Sie diese Marketing-Zustimmung aktivieren möchten?',
    disableTitle: 'Marketing-Zustimmung deaktivieren',
    disableMessage: 'Sind Sie sicher, dass Sie diese Marketing-Zustimmung deaktivieren möchten?',
    toggleSuccess: 'Der Status der Marketing-Zustimmung wurde erfolgreich aktualisiert',
    toggleError: 'Beim Aktualisieren der Marketing-Zustimmung ist ein Fehler aufgetreten',
    consentType: 'Zustimmungstyp',
    selectType: 'Typ auswählen...',
    typeChanged: 'Zustimmungstyp erfolgreich aktualisiert',
    typeChangeError: 'Fehler beim Aktualisieren des Zustimmungstyps',
    visibleFrom: 'Sichtbar ab',
    notYetVisible: 'Noch nicht sichtbar',
    alwaysVisible: 'Immer sichtbar'
  }
}
